/**
 * AUTO-GENERATED from lib/core/Constants.cfc — do not edit by hand.
 * Source: resources/generated/constants.json
 * Generated at: 2026-10-01T23:09:29Z
 * Regenerate: box task run task-export-constants && node scripts/generate-constants-js.mjs
 */
var CONSTANTS = CONSTANTS || {};
var CONST_GROUPS = CONST_GROUPS || {};

CONSTANTS["ACCESS_ACCOUNTCODES"] = "16";
CONSTANTS["ACCESS_ACCOUNTCODES_INDIV"] = "67108864";
CONSTANTS["ACCESS_ACCOUNT_SECURITY"] = "8192";
CONSTANTS["ACCESS_ADD_USERS"] = "128";
CONSTANTS["ACCESS_ASSIGNED_USER_ALERTS"] = "65536";
CONSTANTS["ACCESS_ASSIGNED_USER_HRDOCS"] = "131072";
CONSTANTS["ACCESS_ASSIGNED_USER_PROFILE"] = "2097152";
CONSTANTS["ACCESS_ASSIGNED_USER_RECORDS"] = "32768";
CONSTANTS["ACCESS_BILLABLE_PROP"] = "1";
CONSTANTS["ACCESS_BILLABLE_PROP_INDIV"] = "2";
CONSTANTS["ACCESS_BILLING"] = "1024";
CONSTANTS["ACCESS_BILLING_APPROVE"] = "2048";
CONSTANTS["ACCESS_BILLPAY_RATES"] = "33554432";
CONSTANTS["ACCESS_CUSTOMERS"] = "16384";
CONSTANTS["ACCESS_CUSTOMERS_INDIV"] = "536870912";
CONSTANTS["ACCESS_EVENTS"] = "549755813888";
CONSTANTS["ACCESS_EVENTS_INDIV"] = "1099511627776";
CONSTANTS["ACCESS_NONASSIGNED_ADMINISTRATOR"] = "16777216";
CONSTANTS["ACCESS_NONASSIGNED_SUPERVISOR"] = "8388608";
CONSTANTS["ACCESS_NONASSIGNED_USERS"] = "8";
CONSTANTS["ACCESS_NONASSIGNED_USER_ALERTS"] = "524288";
CONSTANTS["ACCESS_NONASSIGNED_USER_HRDOCS"] = "1048576";
CONSTANTS["ACCESS_NONASSIGNED_USER_PROFILE"] = "4194304";
CONSTANTS["ACCESS_NONASSIGNED_USER_RECORDS"] = "262144";
CONSTANTS["ACCESS_PAYROLL"] = "256";
CONSTANTS["ACCESS_PAYROLL_APPROVE"] = "512";
CONSTANTS["ACCESS_PROJECTS"] = "32";
CONSTANTS["ACCESS_PROJECTS_INDIV"] = "134217728";
CONSTANTS["ACCESS_SNAPSHOT"] = "64";
CONSTANTS["ACCESS_TEAM_STATUS"] = "4";
CONSTANTS["ACCESS_VENDORS"] = "4096";
CONSTANTS["ACCESS_VENDORS_INDIV"] = "268435456";
CONSTANTS["ACCRUALADJUSTMENT_AUTOMATIC"] = "1";
CONSTANTS["ACCRUALADJUSTMENT_REDEEM"] = "3";
CONSTANTS["ACCRUALRATE_ALLRATES"] = "0,1,2,3,4,5,6,7,8";
CONSTANTS["ACCRUALRATE_BYHOUR"] = "6";
CONSTANTS["ACCRUALRATE_DAILY"] = "1";
CONSTANTS["ACCRUALRATE_FIRSTOFMONTH"] = "2";
CONSTANTS["ACCRUALRATE_NONE"] = "0";
CONSTANTS["ACCRUALRATE_ONEWEEK"] = "7";
CONSTANTS["ACCRUALRATE_QUARTERLY"] = "8";
CONSTANTS["ACCRUALRATE_TWICEAMONTH"] = "3";
CONSTANTS["ACCRUALRATE_TWOWEEKS"] = "4";
CONSTANTS["ACCRUALRATE_YEARLY"] = "5";
CONSTANTS["ACCTCODESTATUS_ACTIVE"] = "1";
CONSTANTS["ACCTCODESTATUS_ALL"] = "0,1";
CONSTANTS["ACCTCODESTATUS_ARCHIVED"] = "0";
CONSTANTS["ACF_ENABLE_QUOTES"] = "32";
CONSTANTS["AFFILIATESTATUS_ACTIVE"] = "1";
CONSTANTS["AFFILIATESTATUS_ARCHIVED"] = "2";
CONSTANTS["AFFILIATESTATUS_DELETED"] = "0";
CONSTANTS["ALLOW_HOURLY_ENTRY_WITHOUT_ALERT"] = "32";
CONSTANTS["ALLOW_PROJECT_ENTRY_WITHOUT_ALERT"] = "16";
CONSTANTS["ANNOUNCEMENT_DISPLAY"] = "ANNOUNCEMENT";
CONSTANTS["APIKEY_PERM_ALL"] = "31";
CONSTANTS["APIKEY_PERM_DELETE"] = "16";
CONSTANTS["APIKEY_PERM_GET"] = "1";
CONSTANTS["APIKEY_PERM_PATCH"] = "8";
CONSTANTS["APIKEY_PERM_POST"] = "2";
CONSTANTS["APIKEY_PERM_PUT"] = "4";
CONSTANTS["AUTHORIZATION_TYPE_LIST"] = "0,1,2";
CONSTANTS["AUTHORIZATION_TYPE_NONE"] = "0";
CONSTANTS["AUTHORIZATION_TYPE_PASSWORD"] = "2";
CONSTANTS["AUTHORIZATION_TYPE_PIN"] = "1";
CONSTANTS["AUTODEDUCT_EVERYTIME"] = "2";
CONSTANTS["AUTODEDUCT_NONE"] = "0";
CONSTANTS["AUTODEDUCT_ONETIME"] = "1";
CONSTANTS["AUTODEDUCT_TYPE_LIST"] = "0,1,2";
CONSTANTS["AUTOMATICSHIFTCLOCKOUT_NO"] = "0";
CONSTANTS["AUTOMATICSHIFTCLOCKOUT_YES"] = "1";
CONSTANTS["AUTOMATIC_CLOCKOUT_HOURS"] = "16";
CONSTANTS["BASIC_SUPERVISOR_PERMISSION_FLAGS"] = "1056960763";
CONSTANTS["BILLINGTYPE_ALL"] = "0,1,2,3";
CONSTANTS["BILLINGTYPE_ANNUAL"] = "2";
CONSTANTS["BILLINGTYPE_FREE"] = "3";
CONSTANTS["BILLINGTYPE_MONTHLY"] = "1";
CONSTANTS["BILLINGTYPE_NONE"] = "0";
CONSTANTS["BILLPAY_RATE_MAX"] = "10000";
CONSTANTS["BILLPAY_RATE_MIN"] = "0";
CONSTANTS["CALENDARS_APP"] = "16";
CONSTANTS["CALENDAR_CATEGORY_CUSTOM"] = "CUSTOM";
CONSTANTS["CALENDAR_CATEGORY_DEFAULT"] = "DEFAULT";
CONSTANTS["CALENDAR_CATEGORY_HR"] = "HR";
CONSTANTS["CALENDAR_CATEGORY_REPORT"] = "REPORT";
CONSTANTS["CALENDAR_CATEGORY_SCHEDULE"] = "SCHEDULE";
CONSTANTS["CALENDAR_EVENT_NOT_PUBLISHED"] = "0";
CONSTANTS["CALENDAR_EVENT_PUBLISHED"] = "1";
CONSTANTS["CALENDAR_EVENT_PUBLISH_ALL"] = "1,0";
CONSTANTS["CALENDAR_EVENT_STATUS_ALL"] = "0,1";
CONSTANTS["CALENDAR_EVENT_STATUS_AVAILABLE"] = "0";
CONSTANTS["CALENDAR_EVENT_STATUS_UNAVAILABLE"] = "1";
CONSTANTS["CALENDAR_ID_BIRTHDAYS"] = "BIRTHDAYS";
CONSTANTS["CALENDAR_ID_HIREDATES"] = "HIREDATES";
CONSTANTS["CALENDAR_ID_PAYROLLPERIODS"] = "PAYROLLPERIODS";
CONSTANTS["CALENDAR_ID_REVIEWDATES"] = "REVIEWDATES";
CONSTANTS["CALENDAR_ID_TERMINATIONDATES"] = "TERMINATIONDATES";
CONSTANTS["CALENDAR_ID_USHOLIDAYS"] = "USHOLIDAYS";
CONSTANTS["CALENDAR_PROPERTY_RESET_TRIGGER"] = "[RESET]";
CONSTANTS["CALENDAR_STATUS_ACTIVE"] = "1";
CONSTANTS["CALENDAR_STATUS_ALL"] = "1,0";
CONSTANTS["CALENDAR_STATUS_ARCHIVED"] = "0";
CONSTANTS["CALENDAR_TYPE_ALL"] = "1,2,3";
CONSTANTS["CALENDAR_TYPE_PRIVATE"] = "2";
CONSTANTS["CALENDAR_TYPE_PUBLIC"] = "1";
CONSTANTS["CALENDAR_TYPE_SHARED"] = "3";
CONSTANTS["CANCELLATIONTYPE_IMMEDIATE"] = "2";
CONSTANTS["CANCELLATIONTYPE_STANDARD"] = "1";
CONSTANTS["CANCELLATION_COMPLEXITY"] = "5";
CONSTANTS["CANCELLATION_DIFFICULTY"] = "6";
CONSTANTS["CANCELLATION_DOESNTMEETNEEDS"] = "1";
CONSTANTS["CANCELLATION_NONEED"] = "3";
CONSTANTS["CANCELLATION_OUTOFBUSINESS"] = "2";
CONSTANTS["CANCELLATION_PRICE"] = "4";
CONSTANTS["CANCELLATION_SITEPERFORMANCE"] = "7";
CONSTANTS["CANCELLATION_SWITCHSERVICES"] = "8";
CONSTANTS["CLIENT_SETTINGS_CONTROLS"] = {
  IS_NEW_ENROLLMENT: {
    null: "true",
    type: "boolean"
  }
};
CONSTANTS["CLIENT_SETTINGS_OPTIONS"] = {
  USER_SELECTION: [
    "supervisor",
    "alphabetical"
  ],
  WIDGET_TAB_EXPENSE: [
    "balances"
  ],
  MENU_MODE: [
    "standard",
    "icon"
  ],
  PDF_PRINT_OPTION_INCLUDE_LEGENDS: [
    "NONE",
    "ONE",
    "EVERY"
  ],
  PDF_PRINT_OPTION_INCLUDE_EXTENDED_DATA: [
    "true",
    "false"
  ],
  PROMPT_CLOCKOUT_WARNING: [
    "true",
    "false"
  ],
  PDF_PRINT_OPTION_INCLUDE_PAGE_BREAKS: [
    "true",
    "false"
  ],
  TABLE_SORTING: [
    "individual",
    "grouped"
  ],
  NUMBER_DISPLAY_FORMAT: [
    "decimal",
    "human"
  ],
  PDF_PRINT_OPTION_INCLUDE_SIGS: [
    "NONE",
    "ONE",
    "EVERY"
  ],
  ITEM_SELECTION: [
    "checkboxes",
    "lists"
  ],
  GUIDED_TOURS: [
    "show",
    "hide"
  ],
  PROMPT_CLOCKIN_WARNING: [
    "true",
    "false"
  ],
  PDF_PRINT_OPTION_PRINT_SIZE: [
    "0",
    "1",
    "2",
    "3",
    "4"
  ],
  USER_SELECTION_GROUPING: [
    "supervisor_full",
    "supervisor_indiv"
  ],
  ITEM_ORDERING: [
    "alphabetical",
    "mostrecent"
  ],
  WIDGET_TAB_HOURLY: [
    "balances",
    "payroll",
    "status"
  ],
  TABLE_DISPLAY: [
    "smallFormat",
    "mediumFormat",
    "regularFormat"
  ],
  LOGIN_LANDING_PAGE: [
    "Home",
    "Dashboard",
    "Timesheet",
    "MyExpenses",
    "TimeOffRequest",
    "Schedules",
    "MessageCenter",
    "Notifications",
    "AccountAlerts",
    "Memos",
    "MessageBoard"
  ],
  WIDGET_TAB_PROJECT: [
    "balances"
  ],
  MENU_DISPLAY: [
    "menuOpen",
    "menuClosed",
    "menuAutomatic"
  ],
  REPORT_HEADER_WRAPPING: [
    "true",
    "false"
  ]
};
CONSTANTS["CLOCKINRESTRICTION_NO"] = "0";
CONSTANTS["CLOCKINRESTRICTION_YES"] = "1";
CONSTANTS["COMMISSION_PAYMENT_ACTIVE"] = "1";
CONSTANTS["COMMISSION_PAYMENT_SUSPENDED"] = "0";
CONSTANTS["COMMISSION_PAYMENT_WAITING_PERIOD"] = "90";
CONSTANTS["COMPANYSTATUS_ACTIVE"] = "2";
CONSTANTS["COMPANYSTATUS_ALL"] = "1,2,3,4,5,6,7,8";
CONSTANTS["COMPANYSTATUS_CANCELED"] = "8";
CONSTANTS["COMPANYSTATUS_DELINQUENT"] = "3";
CONSTANTS["COMPANYSTATUS_EXPIRED"] = "4";
CONSTANTS["COMPANYSTATUS_INTRIAL"] = "1";
CONSTANTS["COMPANYSTATUS_NOT_USED"] = "6";
CONSTANTS["COMPANYSTATUS_OTHER"] = "5";
CONSTANTS["COMPANYSTATUS_PENDINGREFERRAL"] = "7";
CONSTANTS["COMPANY_CALENDAR_IDS"] = "USHOLIDAYS,PAYROLLPERIODS";
CONSTANTS["COMPANY_DISABLE_FUTURE_EXPENSE_ENTRY"] = "137438953472";
CONSTANTS["COMPANY_DISABLE_FUTURE_HOURLY_ENTRY"] = "34359738368";
CONSTANTS["COMPANY_DISABLE_FUTURE_PROJECT_ENTRY"] = "68719476736";
CONSTANTS["COMPANY_ENABLE_ACCRUALS"] = "512";
CONSTANTS["COMPANY_ENABLE_AUTOMATIC_CLOCKOUT"] = "262144";
CONSTANTS["COMPANY_ENABLE_CALENDARS"] = "274877906944";
CONSTANTS["COMPANY_ENABLE_CLOCKTIME_EDIT"] = "131072";
CONSTANTS["COMPANY_ENABLE_CUSTOMERS"] = "4294967296";
CONSTANTS["COMPANY_ENABLE_DIRECTORY"] = "1073741824";
CONSTANTS["COMPANY_ENABLE_EMPLOYEE_TIME_ZONE_ACCESS"] = "4096";
CONSTANTS["COMPANY_ENABLE_EXPENSEREPORTS"] = "65536";
CONSTANTS["COMPANY_ENABLE_HOLIDAY"] = "8388608";
CONSTANTS["COMPANY_ENABLE_HOURLY"] = "4";
CONSTANTS["COMPANY_ENABLE_HOURLY_DELETE"] = "8192";
CONSTANTS["COMPANY_ENABLE_HOURLY_EDIT"] = "1";
CONSTANTS["COMPANY_ENABLE_HOURLY_EDIT_WO_REASON"] = "256";
CONSTANTS["COMPANY_ENABLE_HOURLY_ENTRY"] = "1024";
CONSTANTS["COMPANY_ENABLE_HOURLY_ENTRY_WITHOUT_ALERT"] = "2";
CONSTANTS["COMPANY_ENABLE_HRREPORTS"] = "32768";
CONSTANTS["COMPANY_ENABLE_MESSAGE_BOARD"] = "134217728";
CONSTANTS["COMPANY_ENABLE_OTHER1"] = "16777216";
CONSTANTS["COMPANY_ENABLE_OTHER2"] = "33554432";
CONSTANTS["COMPANY_ENABLE_PAID_BREAK"] = "268435456";
CONSTANTS["COMPANY_ENABLE_PASSWORDUPDATE"] = "536870912";
CONSTANTS["COMPANY_ENABLE_PHOTO_SECURITY"] = "524288";
CONSTANTS["COMPANY_ENABLE_PROJECT"] = "8";
CONSTANTS["COMPANY_ENABLE_PROJECT_DELETE"] = "16384";
CONSTANTS["COMPANY_ENABLE_PROJECT_DESCRIPTION_VIEW"] = "67108864";
CONSTANTS["COMPANY_ENABLE_PROJECT_EDIT"] = "128";
CONSTANTS["COMPANY_ENABLE_PROJECT_EDIT_WO_REASON"] = "2147483648";
CONSTANTS["COMPANY_ENABLE_PROJECT_ENTRY"] = "2048";
CONSTANTS["COMPANY_ENABLE_PROJECT_ENTRY_WITHOUT_ALERT"] = "64";
CONSTANTS["COMPANY_ENABLE_PROJECT_SIMULTANEOUS_TIMERS"] = "8589934592";
CONSTANTS["COMPANY_ENABLE_PROJECT_TIME_DEFAULT_BILLABLE"] = "17179869184";
CONSTANTS["COMPANY_ENABLE_PTO"] = "4194304";
CONSTANTS["COMPANY_ENABLE_SICK"] = "1048576";
CONSTANTS["COMPANY_ENABLE_VACATION"] = "2097152";
CONSTANTS["COMPANY_PHOTO_VALIDATION_BY_FACE_DETECT"] = "32";
CONSTANTS["COMPANY_SALESSTATUS_ALL"] = "0,1,2,3,4,5,6";
CONSTANTS["COMPANY_SALESSTATUS_CLOSED"] = "3";
CONSTANTS["COMPANY_SALESSTATUS_GHOST"] = "6";
CONSTANTS["COMPANY_SALESSTATUS_INTRIAL"] = "2";
CONSTANTS["COMPANY_SALESSTATUS_NOCONTACT"] = "5";
CONSTANTS["COMPANY_SALESSTATUS_NONE"] = "0";
CONSTANTS["COMPANY_SALESSTATUS_PROJECT"] = "4";
CONSTANTS["COMPANY_SALESSTATUS_ROLLOUT"] = "1";
CONSTANTS["COMPANY_SEND_PAYMENT_RECEIPT"] = "16";
CONSTANTS["COMPANY_SETTING_NOT_USED_40"] = "549755813888";
CONSTANTS["COMPANY_SETTING_NOT_USED_41"] = "1099511627776";
CONSTANTS["COMPANY_SETTING_NOT_USED_42"] = "2199023255552";
CONSTANTS["COMPTIME_ACCRUAL_MULTIPLIERS"] = "1.00,1.25,1.50,1.75,2.00";
CONSTANTS["CUSTOMERSTATUS_ACTIVE"] = "1";
CONSTANTS["CUSTOMERSTATUS_ALL"] = "0,1";
CONSTANTS["CUSTOMERSTATUS_ARCHIVED"] = "0";
CONSTANTS["DAILY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MAX"] = "24";
CONSTANTS["DAILY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MIN"] = "0.01";
CONSTANTS["DAILY_OVERTIME_HOURS_REQUIRED_FOR_7TH_DAY_DOUBLETIME_MAX"] = "24";
CONSTANTS["DAILY_OVERTIME_HOURS_REQUIRED_FOR_7TH_DAY_DOUBLETIME_MIN"] = "0.01";
CONSTANTS["DATE_DAY_ABBREV"] = "DDD";
CONSTANTS["DATE_MASK_BASIC"] = "mmm dd, yyyy";
CONSTANTS["DATE_MASK_DDMMYYYY_DASH"] = "dd-mm-yyyy";
CONSTANTS["DATE_MASK_DDMMYYYY_SLASH"] = "dd/mm/yyyy";
CONSTANTS["DATE_MASK_EXTENDED"] = "ddd, mmm dd, yyyy";
CONSTANTS["DATE_MASK_EXTENDED2"] = "dddd mmm dd yyyy";
CONSTANTS["DATE_MASK_EXTENDED3"] = "dddd mmmm dd yyyy";
CONSTANTS["DATE_MASK_JSON"] = "mmmm, dd yyyy";
CONSTANTS["DATE_MASK_MMDDYYYY_DASH"] = "mm-dd-yyyy";
CONSTANTS["DATE_MASK_MMDDYYYY_SLASH"] = "mm/dd/yyyy";
CONSTANTS["DATE_MASK_SHORT"] = "mmm dd";
CONSTANTS["DATE_MASK_SHORT2"] = "mmm yyyy";
CONSTANTS["DATE_MASK_YYYYMMDD_ISO"] = "yyyy-mm-dd";
CONSTANTS["DATE_MASK_YYYYMMDD_SLASH"] = "yyyy/mm/dd";
CONSTANTS["DEFAULT_ACCOUNT_ALERT_SENT_BY"] = "Timesheets.com";
CONSTANTS["DEFAULT_ADMIN_PERMISSION_FLAGS"] = "1056962043";
CONSTANTS["DEFAULT_ADMIN_SECURITY_FLAGS"] = "48";
CONSTANTS["DEFAULT_ADMIN_TIME_ZONE_ID"] = "32";
CONSTANTS["DEFAULT_COMMISSION_PERCENTAGE"] = "20";
CONSTANTS["DEFAULT_COMPANY_SETTINGS_FLAGS"] = "296570048237";
CONSTANTS["DEFAULT_EMPLOYEE_DISPLAY_LIST"] = "HOURLY,PROJECT,EXPENSE,ANNOUNCEMENT";
CONSTANTS["DEFAULT_EMPLOYEE_PERMISSION_FLAGS"] = "0";
CONSTANTS["DEFAULT_EMPLOYEE_SECURITY_FLAGS"] = "1";
CONSTANTS["DEFAULT_ENABLED_USER_APPS"] = "15";
CONSTANTS["DEFAULT_NOTIFICATION_SENT_BY"] = "Timesheets.com";
CONSTANTS["DEFAULT_PRIMARY_ADMIN_PERMISSION_FLAGS"] = "1073739259";
CONSTANTS["DEFAULT_SIGNATURE_TEXT"] = "By signing above I acknowledge and certify that the information contained on this document is true and accurate.";
CONSTANTS["DEFAULT_SUPERVISOR_PERMISSION_FLAGS"] = "0";
CONSTANTS["DEFAULT_SUPERVISOR_SECURITY_FLAGS"] = "1";
CONSTANTS["DOWNLOAD_FILE_EXPIRATION"] = "2592000";
CONSTANTS["EMAIL_CLOCKOUT_REMINDER"] = "8";
CONSTANTS["EMAIL_NEW_HOURLY_ALERTS"] = "16";
CONSTANTS["EMAIL_NEW_PROJECT_ALERTS"] = "32";
CONSTANTS["EMAIL_STATUSREPORT_DAILY"] = "1";
CONSTANTS["EMAIL_STATUSREPORT_LIST"] = "1,2,4";
CONSTANTS["EMAIL_STATUSREPORT_MONTHLY"] = "4";
CONSTANTS["EMAIL_STATUSREPORT_WEEKLY"] = "2";
CONSTANTS["EMPLOYEETYPE_CONTRACTOR"] = "2";
CONSTANTS["EMPLOYEETYPE_EMP"] = "1";
CONSTANTS["EMPLOYEETYPE_OTHER"] = "5";
CONSTANTS["EMPLOYEETYPE_STUDENT"] = "4";
CONSTANTS["EMPLOYEETYPE_VOLUNTEER"] = "3";
CONSTANTS["ERROR_CLOCK_CLOCK_OUT_INTERFERES_WITH_PAID_BREAK"] = "200016";
CONSTANTS["ERROR_CLOCK_CLOCK_OUT_LATER_THAN_CLOCK_IN"] = "200015";
CONSTANTS["ERROR_CLOCK_EDIT_REASON_REQUIRED"] = "200011";
CONSTANTS["ERROR_CLOCK_EDIT_REASON_TOO_SHORT"] = "200012";
CONSTANTS["ERROR_CLOCK_GEOLOCATION_REQUIRED"] = "200005";
CONSTANTS["ERROR_CLOCK_IP_ADDRESS_INVALID"] = "200006";
CONSTANTS["ERROR_CLOCK_PAID_BREAK_ALREADY_TAKEN"] = "200014";
CONSTANTS["ERROR_CLOCK_PAID_BREAK_NOT_ENABLED"] = "200013";
CONSTANTS["ERROR_CLOCK_PHOTO_REQUIRED"] = "200008";
CONSTANTS["ERROR_CLOCK_SHIFT_EDIT_LATER_THAN_CLOCK_OUT"] = "200004";
CONSTANTS["ERROR_CLOCK_SHIFT_EDIT_LATER_THAN_CURRENT"] = "200003";
CONSTANTS["ERROR_CLOCK_SHIFT_RESTRICTED"] = "200007";
CONSTANTS["ERROR_CLOCK_TIME_ARGUMENT_CONFLICT"] = "200017";
CONSTANTS["ERROR_CLOCK_TIME_EDIT_DISABLED"] = "200009";
CONSTANTS["ERROR_CLOCK_TIME_VALUE_INVALID"] = "200010";
CONSTANTS["ERROR_CLOCK_USER_CLOCKED_IN"] = "200002";
CONSTANTS["ERROR_CLOCK_USER_NOT_CLOCKED_IN"] = "200001";
CONSTANTS["ERROR_GENERAL_ACCOUNT_AUTHORIZATION_FAILED"] = "100004";
CONSTANTS["ERROR_GENERAL_COMPANYID_NOT_FOUND"] = "100009";
CONSTANTS["ERROR_GENERAL_COMPANY_USER_MISMATCH"] = "100010";
CONSTANTS["ERROR_GENERAL_DUPLICATE_REQUEST"] = "100002";
CONSTANTS["ERROR_GENERAL_EXPENSE_TRACKING_NOT_ENABLED"] = "100007";
CONSTANTS["ERROR_GENERAL_HOURLY_TRACKING_NOT_ENABLED"] = "100005";
CONSTANTS["ERROR_GENERAL_IDEMPOTENCY_TOKEN_INVALID"] = "100001";
CONSTANTS["ERROR_GENERAL_NO_PERMISSION_FOR_ACTION"] = "100008";
CONSTANTS["ERROR_GENERAL_PROJECT_TRACKING_NOT_ENABLED"] = "100006";
CONSTANTS["ERROR_GENERAL_USERID_NOT_FOUND"] = "100003";
CONSTANTS["ERROR_LIST_ACCOUNTCODEID_INVALID"] = "300003";
CONSTANTS["ERROR_LIST_CUSTOMERID_INVALID"] = "300001";
CONSTANTS["ERROR_LIST_EVENTID_INVALID"] = "300005";
CONSTANTS["ERROR_LIST_PROJECTID_INVALID"] = "300002";
CONSTANTS["ERROR_LIST_VENDORID_INVALID"] = "300004";
CONSTANTS["EVENTSTATUS_ACTIVE"] = "1";
CONSTANTS["EVENTSTATUS_ALL"] = "0,1";
CONSTANTS["EVENTSTATUS_ARCHIVED"] = "0";
CONSTANTS["EXPENSERECORDSTATUS_ALL"] = "0,1";
CONSTANTS["EXPENSERECORDSTATUS_OPEN"] = "0";
CONSTANTS["EXPENSERECORDSTATUS_RECONCILED"] = "1";
CONSTANTS["EXPENSEREPORTS_APP"] = "4";
CONSTANTS["EXPENSE_DISPLAY"] = "EXPENSE";
CONSTANTS["EXPENSE_RECORD"] = "6";
CONSTANTS["FACIAL_DETECTION_CONFIDENCE_THRESHOLD"] = "95";
CONSTANTS["FINGERPRINTSTATUS_ACTIVE_ENABLED"] = "1";
CONSTANTS["FINGERPRINTSTATUS_INACTIVE"] = "0";
CONSTANTS["FINGERPRINT_LOGIN_REQUIRED"] = "8";
CONSTANTS["FLAGGED_FOR_ALL"] = "3";
CONSTANTS["FLAGGED_FOR_EMPLOYEE"] = "1";
CONSTANTS["FLAGGED_FOR_SUPERVISOR"] = "2";
CONSTANTS["GEOLOCATION_REQUIRED"] = "128";
CONSTANTS["GUSTO_ON_UNMATCHED_FAIL"] = "fail";
CONSTANTS["GUSTO_ON_UNMATCHED_WARN"] = "warn";
CONSTANTS["HOURLYRECORDSTATUS_ALL"] = "0,1,2,3";
CONSTANTS["HOURLYRECORDSTATUS_ARCHIVED"] = "3";
CONSTANTS["HOURLYRECORDSTATUS_OPEN"] = "0";
CONSTANTS["HOURLYRECORDSTATUS_OPEN_PAID_LIST"] = "0,1";
CONSTANTS["HOURLYRECORDSTATUS_PAID"] = "1";
CONSTANTS["HOURLYRECORDSTATUS_REPORT_DEFAULT"] = "0,1,3";
CONSTANTS["HOURLYRECORDSTATUS_SPLITPAID"] = "2";
CONSTANTS["HOURLYRECORDSTATUS_SPLITPAID_OPEN"] = "21";
CONSTANTS["HOURLYRECORDSTATUS_SPLITPAID_PAID"] = "22";
CONSTANTS["HOURLYTRACKING_APP"] = "1";
CONSTANTS["HOURLY_DISPLAY"] = "HOURLY";
CONSTANTS["HOURLY_NSTD_RECORD"] = "3";
CONSTANTS["HOURLY_RECORD"] = "1";
CONSTANTS["HOURLY_STD_RECORD"] = "2";
CONSTANTS["HRDOCUMENTS_APP"] = "8";
CONSTANTS["HRREPORT_ALL"] = "1,2,3,4,5,6";
CONSTANTS["HRREPORT_COMMENDATION"] = "2";
CONSTANTS["HRREPORT_DISCIPLINE"] = "3";
CONSTANTS["HRREPORT_INCIDENT"] = "5";
CONSTANTS["HRREPORT_PERFORMANCEREVIEW"] = "1";
CONSTANTS["HRREPORT_TERMINATION"] = "4";
CONSTANTS["HRREPORT_TERMINATION_ARCHIVED"] = "6";
CONSTANTS["HR_CALENDAR_IDS"] = "REVIEWDATES,BIRTHDAYS,HIREDATES,TERMINATIONDATES";
CONSTANTS["HR_DISPLAY"] = "HR";
CONSTANTS["IMAGE_BRANDLOGO_MAXSIZE"] = "280x100";
CONSTANTS["IMAGE_EXPENSE_MAXSIZE"] = "1600x1600";
CONSTANTS["IMAGE_THUMBNAIL_MAXSIZE"] = "320x320";
CONSTANTS["IP_LOCK_REQUIRED"] = "1";
CONSTANTS["LOCATION_COORDS_PERMISSION_ERROR"] = "999.99999,999.99999:99999";
CONSTANTS["LOCATION_COORDS_UNAVAILABLE"] = "000.00000,000.00000:00000";
CONSTANTS["LOGIN_DISABLED"] = "3";
CONSTANTS["LOGIN_EMPTY_CREDENTIALS"] = "5";
CONSTANTS["LOGIN_INVALID_KEY"] = "4";
CONSTANTS["LOGIN_INVALID_USERNAME_PASSWORD"] = "1";
CONSTANTS["LOGIN_LANDING_PAGES"] = {
  MyExpenses: "default.cfm?page=Timesheet&DisplayMode=EXPENSE",
  MessageBoard: "default.cfm?page=MessageCenter&SelectedTab=MessageBoard",
  Home: "default.cfm?page=Home",
  TimeOffRequest: "default.cfm?page=Home&SelectedTab=ManualEntry&DisplayMode=HOURLY",
  Notifications: "default.cfm?page=MessageCenter&SelectedTab=Notifications",
  MessageCenter: "default.cfm?page=MessageCenter",
  Memos: "default.cfm?page=MessageCenter&SelectedTab=Memos",
  AccountAlerts: "default.cfm?page=MessageCenter&SelectedTab=AccountAlerts",
  Timesheet: "default.cfm?page=Timesheet",
  Dashboard: "default.cfm?page=Dashboard",
  Schedules: "default.cfm?page=Schedules"
};
CONSTANTS["LOGIN_SUCCESSFUL"] = "0";
CONSTANTS["LOGIN_TOO_MANY_ATTEMPTS"] = "2";
CONSTANTS["LOGIN_UNKNOWN"] = "-1";
CONSTANTS["MAXIMUM_ONCLOCK_HOURS"] = "4320";
CONSTANTS["MAX_HOURLY_RECORDS_PER_IMPORT"] = "1000";
CONSTANTS["MAX_ITEM_IMPORT_PER_PERIOD"] = "1500";
CONSTANTS["MAX_PROJECT_RECORDS_PER_IMPORT"] = "1000";
CONSTANTS["MAX_ROWS_OPTIONS"] = [
  {
    display: "1 (debug)",
    value: "1",
    debugOnly: true
  },
  {
    display: "3 (debug)",
    value: "3",
    debugOnly: true
  },
  {
    display: "5 (debug)",
    value: "5",
    debugOnly: true
  },
  {
    display: "10",
    value: "10",
    debugOnly: false
  },
  {
    display: "20",
    value: "20",
    debugOnly: false
  },
  {
    display: "40",
    value: "40",
    debugOnly: false
  },
  {
    display: "80",
    value: "80",
    debugOnly: false
  },
  {
    display: "120",
    value: "120",
    debugOnly: false
  },
  {
    display: "160",
    value: "160",
    debugOnly: false
  },
  {
    display: "200",
    value: "200",
    debugOnly: false
  }
];
CONSTANTS["MAX_SITEADMIN_LOGIN_ATTEMPTS"] = "5";
CONSTANTS["MAX_USERS_PER_IMPORT"] = "75";
CONSTANTS["MAX_USER_LOGIN_ATTEMPTS"] = "5";
CONSTANTS["MEMO_MAX_LENGTH"] = "10000";
CONSTANTS["MESSAGE_BOARD_MAX_MSG_LENGTH"] = "5000";
CONSTANTS["MESSAGE_CENTER_NOTIFICATION_KEY_DELIMITER"] = "~";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_DOUBLETIME_MAX"] = "24";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_DOUBLETIME_MIN"] = "0.01";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_OT_MAX"] = "24";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_OT_MIN"] = "0.01";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_WEEK_OT_MAX"] = "168";
CONSTANTS["MINIMUM_HOURS_FOR_DAILY_WEEK_OT_MIN"] = "0.01";
CONSTANTS["MINIMUM_HOURS_FOR_WEEKLY_OT_MAX"] = "168";
CONSTANTS["MINIMUM_HOURS_FOR_WEEKLY_OT_MIN"] = "0.01";
CONSTANTS["MINIMUM_QUALIFYING_DAYS_FOR_7TH_DAY_OT_LIST"] = "6,7";
CONSTANTS["MIN_DAYS_FOR_BILLING_PRORATE"] = "3";
CONSTANTS["MIN_LENGTH_FOR_EDIT_REASON"] = "6";
CONSTANTS["NOTE_STATUS_ANY"] = "0,1";
CONSTANTS["NOTE_STATUS_CLOSED"] = "0";
CONSTANTS["NOTE_STATUS_OPEN"] = "1";
CONSTANTS["NOTE_TYPE_ABOUT"] = "7";
CONSTANTS["NOTE_TYPE_ANY"] = "0,1,2,3,4,5,6,7,8,9,10,11";
CONSTANTS["NOTE_TYPE_BILLING_RELATED"] = "5";
CONSTANTS["NOTE_TYPE_BUG_REPORT"] = "6";
CONSTANTS["NOTE_TYPE_CUSTOMER_COMMENT"] = "4";
CONSTANTS["NOTE_TYPE_CUSTOMER_SUGGESTION"] = "8";
CONSTANTS["NOTE_TYPE_GENERAL"] = "0";
CONSTANTS["NOTE_TYPE_GROUP_ALL"] = "102";
CONSTANTS["NOTE_TYPE_GROUP_ANYOPEN"] = "104";
CONSTANTS["NOTE_TYPE_GROUP_CUSTSRV"] = "101";
CONSTANTS["NOTE_TYPE_GROUP_READMEOROPEN"] = "103";
CONSTANTS["NOTE_TYPE_INCIDENT"] = "10";
CONSTANTS["NOTE_TYPE_NO_SALE"] = "11";
CONSTANTS["NOTE_TYPE_README"] = "2";
CONSTANTS["NOTE_TYPE_RETENTION"] = "1";
CONSTANTS["NOTE_TYPE_SPECIAL_OFFER"] = "3";
CONSTANTS["NOTE_TYPE_TRIAL_COMMENT"] = "9";
CONSTANTS["NOTIFICATION_CLOCKOUT_LINK"] = "4";
CONSTANTS["NOTIFICATION_EMPLOYEE_AUTOMATIC_CLOCKOUT_PERSONAL"] = "7";
CONSTANTS["NOTIFICATION_EMPLOYEE_AUTOMATIC_CLOCKOUT_SUPERVISOR"] = "8";
CONSTANTS["NOTIFICATION_EMPLOYEE_CLOCKIN"] = "5";
CONSTANTS["NOTIFICATION_EMPLOYEE_CLOCKOUT"] = "1";
CONSTANTS["NOTIFICATION_EMPLOYEE_CLOCKOUT_SHIFT_EXCEEDED"] = "6";
CONSTANTS["NOTIFICATION_EMPLOYEE_ELECTIVE_ACTION"] = "11";
CONSTANTS["NOTIFICATION_HOURLY_ALERT_CREATED"] = "2";
CONSTANTS["NOTIFICATION_LAST_DAY_OF_PAY_PERIOD"] = "9";
CONSTANTS["NOTIFICATION_PROJECT_ALERT_CREATED"] = "3";
CONSTANTS["NOTIFICATION_STILL_ON_CLOCK_REMINDER"] = "10";
CONSTANTS["NOT_FLAGGED"] = "0";
CONSTANTS["NOT_USED_SECURITY_SETTING"] = "2";
CONSTANTS["NUM_MASK_2D"] = ".00";
CONSTANTS["NUM_MASK_3D"] = ".000";
CONSTANTS["NUM_MASK_5D"] = ".00000";
CONSTANTS["ORIGINATION_TYPE_CLOCK"] = "1";
CONSTANTS["ORIGINATION_TYPE_CLOCK_KIOSK"] = "7";
CONSTANTS["ORIGINATION_TYPE_CLOCK_MOBILE"] = "2";
CONSTANTS["ORIGINATION_TYPE_IMPORT"] = "8";
CONSTANTS["ORIGINATION_TYPE_TIMER"] = "5";
CONSTANTS["ORIGINATION_TYPE_TIMER_MOBILE"] = "6";
CONSTANTS["ORIGINATION_TYPE_TIME_ENTRY"] = "3";
CONSTANTS["ORIGINATION_TYPE_TIME_ENTRY_MOBILE"] = "4";
CONSTANTS["ORIGINATION_TYPE_UNKNOWN"] = "0";
CONSTANTS["OVERTIME_DAILY"] = "3";
CONSTANTS["OVERTIME_LIST"] = "1,2,3";
CONSTANTS["OVERTIME_NONE"] = "1";
CONSTANTS["OVERTIME_WEEKLY"] = "2";
CONSTANTS["PAID_BREAK_DURATIONS"] = [
  "0",
  "10",
  "15",
  "20",
  "30",
  "60"
];
CONSTANTS["PAYMENTSYSTEM_ALL"] = "1,2,3";
CONSTANTS["PAYMENTSYSTEM_MANUAL"] = "3";
CONSTANTS["PAYMENTSYSTEM_PAYPAL"] = "1";
CONSTANTS["PAYMENTSYSTEM_STRIPE"] = "2";
CONSTANTS["PAYMENTTYPE_ACTIVATION"] = "1";
CONSTANTS["PAYMENTTYPE_CANCELLATION"] = "4";
CONSTANTS["PAYMENTTYPE_MODIFY"] = "2";
CONSTANTS["PAYMENTTYPE_REACTIVATION"] = "5";
CONSTANTS["PAYMENTTYPE_UPDATE"] = "3";
CONSTANTS["PAYMENTUPDATE_ALL"] = "0,1,2";
CONSTANTS["PAYMENTUPDATE_BILLINGDATE"] = "2";
CONSTANTS["PAYMENTUPDATE_NONE"] = "0";
CONSTANTS["PAYMENTUPDATE_PROFILE"] = "1";
CONSTANTS["PAYPERIOD_ANY"] = "0,1,2,3,4";
CONSTANTS["PAYPERIOD_BIMONTHLY"] = "4";
CONSTANTS["PAYPERIOD_BIWEEKLY"] = "2";
CONSTANTS["PAYPERIOD_MONTHLY"] = "3";
CONSTANTS["PAYPERIOD_NONE"] = "0";
CONSTANTS["PAYPERIOD_SCHEDULED_LIST"] = "1,2,3,4";
CONSTANTS["PAYPERIOD_WEEKLY"] = "1";
CONSTANTS["PAYROLLCUSTOMERSTATUS_ACTIVE"] = "1";
CONSTANTS["PAYROLLCUSTOMERSTATUS_ALL"] = "0,1,2,3";
CONSTANTS["PAYROLLCUSTOMERSTATUS_INACTIVE"] = "0";
CONSTANTS["PAYROLLCUSTOMERSTATUS_LEAD"] = "2";
CONSTANTS["PAYROLLCUSTOMERSTATUS_LOSTLEAD"] = "3";
CONSTANTS["PAYROLL_ACTION_ALL"] = "IGNORE,ERROR,WARNING";
CONSTANTS["PAYROLL_ACTION_ERROR"] = "ERROR";
CONSTANTS["PAYROLL_ACTION_IGNORE"] = "IGNORE";
CONSTANTS["PAYROLL_ACTION_WARNING"] = "WARNING";
CONSTANTS["PAYROLL_CODE_ALERTS_EXIST"] = "7";
CONSTANTS["PAYROLL_CODE_DUPLICATE_USERS_FOUND"] = "10";
CONSTANTS["PAYROLL_CODE_FLSA_CHRONOLOGICAL_ORDER_VIOLATION"] = "26";
CONSTANTS["PAYROLL_CODE_FLSA_INVALID_TIME_RECORD"] = "25";
CONSTANTS["PAYROLL_CODE_INVALID_ACCRUAL_SETTINGS_FOR_USER"] = "23";
CONSTANTS["PAYROLL_CODE_INVALID_APPEND_PAYROLLID"] = "16";
CONSTANTS["PAYROLL_CODE_INVALID_DATES"] = "3";
CONSTANTS["PAYROLL_CODE_INVALID_PARTIAL_USER_DELETE"] = "20";
CONSTANTS["PAYROLL_CODE_INVALID_PAYROLLID"] = "19";
CONSTANTS["PAYROLL_CODE_INVALID_RUNBYID"] = "15";
CONSTANTS["PAYROLL_CODE_INVALID_TIME_ZONE_FOR_PERIOD"] = "21";
CONSTANTS["PAYROLL_CODE_LOCKED"] = "2";
CONSTANTS["PAYROLL_CODE_NONSEQUENTIAL_RECORDS"] = "22";
CONSTANTS["PAYROLL_CODE_NO_RECORDS_FOUND"] = "4";
CONSTANTS["PAYROLL_CODE_NO_USERS_INCLUDED"] = "11";
CONSTANTS["PAYROLL_CODE_OVERLAPPING_PERIODS"] = "5";
CONSTANTS["PAYROLL_CODE_OVERLAPPING_RECORDS"] = "6";
CONSTANTS["PAYROLL_CODE_PROCESSED"] = "0";
CONSTANTS["PAYROLL_CODE_PROCESS_VALIDATION_ERROR"] = "8";
CONSTANTS["PAYROLL_CODE_PROCESS_VALIDATION_FAILED"] = "9";
CONSTANTS["PAYROLL_CODE_RECORDS_EXCEED_MAX_THRESHOLD"] = "24";
CONSTANTS["PAYROLL_CODE_SALARIED_SPLITPAID_RECORDS_EXISTS"] = "14";
CONSTANTS["PAYROLL_CODE_STANDARD_SPLITPAID_RECORDS_EXISTS"] = "13";
CONSTANTS["PAYROLL_CODE_SUMMARY_ONLY"] = "1";
CONSTANTS["PAYROLL_CODE_UNPAID_RECORDS_EXISTS"] = "12";
CONSTANTS["PAYROLL_CODE_USERS_ALREADY_EXIST_IN_PAYROLL"] = "17";
CONSTANTS["PAYROLL_CODE_USERS_HAVE_POSTDATED_PAYROLL"] = "18";
CONSTANTS["PAYROLL_GUSTO_BACKGROUND_JOB_STALE_MINUTES"] = "120";
CONSTANTS["PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_DELETE_ALL"] = "3";
CONSTANTS["PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_DELETE_PERIOD"] = "2";
CONSTANTS["PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_SYNC"] = "1";
CONSTANTS["PAYROLL_GUSTO_SYNC_CONNECTION_ERROR"] = "999999";
CONSTANTS["PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_ID"] = "100004";
CONSTANTS["PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_PERIOD"] = "100003";
CONSTANTS["PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER"] = "100005";
CONSTANTS["PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER_ID"] = "100006";
CONSTANTS["PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER_NAME"] = "100007";
CONSTANTS["PAYROLL_GUSTO_SYNC_MULTIPLE_UNPROCESSED_PAYROLLS"] = "100002";
CONSTANTS["PAYROLL_GUSTO_SYNC_NO_UNPROCESSED_PAYROLLS"] = "100001";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_BLOCKED_UNMATCHED"] = "5";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_FAILED"] = "6";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_SKIPPED_UNMATCHED"] = "4";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_STATUS_NOT_APPLICABLE"] = "3";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_STATUS_NOT_RUN"] = "1";
CONSTANTS["PAYROLL_GUSTO_SYNC_USER_STATUS_SYNCED"] = "2";
CONSTANTS["PAYROLL_MULTITHREAD_THRESHOLD"] = "25";
CONSTANTS["PAYROLL_RECORD_TYPE_ALL"] = "0,1,2";
CONSTANTS["PAYROLL_RECORD_TYPE_PTO"] = "2";
CONSTANTS["PAYROLL_RECORD_TYPE_TIME_SHEET"] = "1";
CONSTANTS["PAYROLL_RECORD_TYPE_UNKNOWN"] = "0";
CONSTANTS["PAY_TYPE_HOURLY"] = "HOURLY";
CONSTANTS["PAY_TYPE_SALARY"] = "SALARY";
CONSTANTS["PERFORMANCEREVIEW_ANNUAL"] = "4";
CONSTANTS["PERFORMANCEREVIEW_GROUP"] = "1,2,3,4,5,6";
CONSTANTS["PERFORMANCEREVIEW_MONTHLY"] = "1";
CONSTANTS["PERFORMANCEREVIEW_QUARTERLY"] = "2";
CONSTANTS["PERFORMANCEREVIEW_SEMIANNUAL"] = "3";
CONSTANTS["PERFORMANCEREVIEW_UNSCHEDULED"] = "6";
CONSTANTS["PERFORMANCEREVIEW_WEEKLY"] = "5";
CONSTANTS["PHOTOSECURITYSTATUS_ACTIVE"] = "1";
CONSTANTS["PHOTOSECURITYSTATUS_INACTIVE"] = "0";
CONSTANTS["PHOTO_TIMESTAMP_REQUIRED"] = "4";
CONSTANTS["PROJECTRECORDSTATUS_ACTIVE"] = "0";
CONSTANTS["PROJECTRECORDSTATUS_ALL"] = "0,1";
CONSTANTS["PROJECTRECORDSTATUS_ARCHIVED"] = "1";
CONSTANTS["PROJECTSTATUS_ACTIVE"] = "1";
CONSTANTS["PROJECTSTATUS_ALL"] = "0,1";
CONSTANTS["PROJECTSTATUS_ARCHIVED"] = "0";
CONSTANTS["PROJECTTRACKING_APP"] = "2";
CONSTANTS["PROJECT_DISPLAY"] = "PROJECT";
CONSTANTS["PROJECT_MINIMUM_INCREMENTS"] = [
  "0",
  "6",
  "8",
  "10",
  "15",
  "20",
  "30",
  "60"
];
CONSTANTS["PROJECT_RECORD"] = "4";
CONSTANTS["PROJECT_TIMER_RECORD"] = "5";
CONSTANTS["PROMOCODE_ALL"] = "1,2,3";
CONSTANTS["PROMOCODE_DISCOUNT"] = "2";
CONSTANTS["PROMOCODE_DISCOUNT_IN_PERP"] = "3";
CONSTANTS["PROMOCODE_FREETERM"] = "1";
CONSTANTS["QTF_ENABLE_QUOTES"] = "1";
CONSTANTS["QUOTE_ACTIVE"] = "0";
CONSTANTS["QUOTE_ALL"] = "0,1";
CONSTANTS["QUOTE_ARCHIVED"] = "1";
CONSTANTS["QUOTE_CLIENT_ACTION_ACCEPTED"] = "1";
CONSTANTS["QUOTE_CLIENT_ACTION_ALL"] = "0,1,2,3";
CONSTANTS["QUOTE_CLIENT_ACTION_REJECTED"] = "2";
CONSTANTS["QUOTE_CLIENT_ACTION_REVISION_REQUESTED"] = "3";
CONSTANTS["QUOTE_CLIENT_ACTION_UNKNOWN"] = "0";
CONSTANTS["QUOTE_ITEM_DESCRIPTION_MAX_LENGTH"] = "2000";
CONSTANTS["QUOTE_MANUAL_ACTION_ACCEPTED"] = "1";
CONSTANTS["QUOTE_MANUAL_ACTION_ALL"] = "1,2,3";
CONSTANTS["QUOTE_MANUAL_ACTION_DECLINED"] = "2";
CONSTANTS["QUOTE_MANUAL_ACTION_REVISION_REQUESTED"] = "3";
CONSTANTS["QUOTE_RECURRING_ALL"] = "0,1,2,3,4,5,6,7";
CONSTANTS["QUOTE_RECURRING_ANNUALLY"] = "7";
CONSTANTS["QUOTE_RECURRING_BIWEEKLY"] = "2";
CONSTANTS["QUOTE_RECURRING_MONTHLY"] = "4";
CONSTANTS["QUOTE_RECURRING_NONE"] = "0";
CONSTANTS["QUOTE_RECURRING_QUARTERLY"] = "5";
CONSTANTS["QUOTE_RECURRING_SEMIANNUALLY"] = "6";
CONSTANTS["QUOTE_RECURRING_SEMIMONTHLY"] = "3";
CONSTANTS["QUOTE_RECURRING_WEEKLY"] = "1";
CONSTANTS["QUOTE_STATUS_ALL"] = "0,1,2,3,4,5,6,7";
CONSTANTS["QUOTE_STATUS_APPROVED"] = "3";
CONSTANTS["QUOTE_STATUS_ARCHIVED"] = "6";
CONSTANTS["QUOTE_STATUS_DRAFT"] = "1";
CONSTANTS["QUOTE_STATUS_EXPIRED"] = "5";
CONSTANTS["QUOTE_STATUS_NEW"] = "7";
CONSTANTS["QUOTE_STATUS_REJECTED"] = "4";
CONSTANTS["QUOTE_STATUS_REQUESTED"] = "2";
CONSTANTS["QUOTE_STATUS_REVISION_ALL"] = "0,1,2,3,4,5,6,7";
CONSTANTS["QUOTE_STATUS_REVISION_APPROVED"] = "3";
CONSTANTS["QUOTE_STATUS_REVISION_ARCHIVED"] = "6";
CONSTANTS["QUOTE_STATUS_REVISION_DRAFT"] = "1";
CONSTANTS["QUOTE_STATUS_REVISION_EXPIRED"] = "5";
CONSTANTS["QUOTE_STATUS_REVISION_LOCKED"] = "7";
CONSTANTS["QUOTE_STATUS_REVISION_REJECTED"] = "4";
CONSTANTS["QUOTE_STATUS_REVISION_REQUESTED"] = "2";
CONSTANTS["QUOTE_STATUS_REVISION_UNKNOWN"] = "0";
CONSTANTS["QUOTE_STATUS_UNKNOWN"] = "0";
CONSTANTS["RECORD_ALERT"] = "2";
CONSTANTS["RECORD_APPROVED"] = "1";
CONSTANTS["RECORD_APPROVED_STATUS_ALL"] = "0,1,2";
CONSTANTS["RECORD_APPROVED_UNAPPROVED_LIST"] = "0,1";
CONSTANTS["RECORD_BILLABLE"] = "1";
CONSTANTS["RECORD_BILLABLE_ALL"] = "0,1";
CONSTANTS["RECORD_SIGNED"] = "1";
CONSTANTS["RECORD_SIGNED_ALL"] = "0,1";
CONSTANTS["RECORD_UNAPPROVED"] = "0";
CONSTANTS["RECORD_UNBILLABLE"] = "0";
CONSTANTS["RECORD_UNSIGNED"] = "0";
CONSTANTS["REFERRALMETHOD_ADOBE"] = "16";
CONSTANTS["REFERRALMETHOD_AFFILIATE"] = "1";
CONSTANTS["REFERRALMETHOD_ALL"] = "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19";
CONSTANTS["REFERRALMETHOD_APA"] = "19";
CONSTANTS["REFERRALMETHOD_APPLE"] = "5";
CONSTANTS["REFERRALMETHOD_BLOG"] = "14";
CONSTANTS["REFERRALMETHOD_BUYERZONE"] = "4";
CONSTANTS["REFERRALMETHOD_CUSTOMER"] = "2";
CONSTANTS["REFERRALMETHOD_FACEBOOK"] = "18";
CONSTANTS["REFERRALMETHOD_INCDOTCOM"] = "8";
CONSTANTS["REFERRALMETHOD_LINKEDIN"] = "17";
CONSTANTS["REFERRALMETHOD_NOTSPECIFIED"] = "0";
CONSTANTS["REFERRALMETHOD_OTHER"] = "15";
CONSTANTS["REFERRALMETHOD_PAYROLLCOMPANY"] = "6";
CONSTANTS["REFERRALMETHOD_PRINTAD"] = "9";
CONSTANTS["REFERRALMETHOD_RESELLER"] = "12";
CONSTANTS["REFERRALMETHOD_SALESFORCE"] = "11";
CONSTANTS["REFERRALMETHOD_SEARCHENGINE"] = "3";
CONSTANTS["REFERRALMETHOD_TELEPHONE"] = "13";
CONSTANTS["REFERRALMETHOD_TVRADIO"] = "10";
CONSTANTS["REFERRALMETHOD_WORDOFMOUTH"] = "7";
CONSTANTS["REPORT_TYPE_ALL"] = "1,2,3";
CONSTANTS["REPORT_TYPE_EXPENSE"] = "3";
CONSTANTS["REPORT_TYPE_HOURLY"] = "1";
CONSTANTS["REPORT_TYPE_PROJECT"] = "2";
CONSTANTS["SALES_ASSOCIATE_ASSIGNMENT_BY_LEAST_BUSY"] = "LEAST_BUSY";
CONSTANTS["SALES_ASSOCIATE_ASSIGNMENT_BY_USER_TIER"] = "USER_TIER";
CONSTANTS["SCHEDULE_DATE_SELECTION_BY_DAY"] = "1";
CONSTANTS["SCHEDULE_DATE_SELECTION_BY_WEEK"] = "2";
CONSTANTS["SCHEDULE_LIST_DISPLAY_BY_ALPHA"] = "2";
CONSTANTS["SCHEDULE_LIST_DISPLAY_BY_HIER"] = "1";
CONSTANTS["SCHEDULE_VIEWABLE_PEER_ALL"] = "17179869184";
CONSTANTS["SCHEDULE_VIEWABLE_PEER_DIRECT"] = "4294967296";
CONSTANTS["SCHEDULE_VIEWABLE_PEER_LOCAL"] = "8589934592";
CONSTANTS["SCHEDULE_VIEWABLE_SUB_ALL"] = "137438953472";
CONSTANTS["SCHEDULE_VIEWABLE_SUB_DIRECT"] = "34359738368";
CONSTANTS["SCHEDULE_VIEWABLE_SUB_LOCAL"] = "68719476736";
CONSTANTS["SCHEDULE_VIEWABLE_SUPER_ALL"] = "2147483648";
CONSTANTS["SCHEDULE_VIEWABLE_SUPER_DIRECT"] = "274877906944";
CONSTANTS["SCHEDULE_VIEWABLE_SUPER_LOCAL"] = "1073741824";
CONSTANTS["SESSION_TIMEOUT_20MIN"] = "20";
CONSTANTS["SESSION_TIMEOUT_21DAY"] = "21";
CONSTANTS["SESSION_TIMEOUT_30SEC"] = "30";
CONSTANTS["SESSION_TIMEOUT_5MIN"] = "5";
CONSTANTS["SESSION_TIMEOUT_60MIN"] = "60";
CONSTANTS["SESSION_TIMEOUT_7DAY"] = "0";
CONSTANTS["SESSION_TIMEOUT_LIST"] = "0,5,20,30,60,21";
CONSTANTS["SITEADMIN_ACCESS_RESTRICTED_NOTIFICATIONS"] = "1024";
CONSTANTS["SITEADMIN_CLEAR_COMPANY_SEARCHFORM_ON_SUBMIT"] = "2048";
CONSTANTS["SITEADMIN_DEFAULT_REFERRAL_MANAGER"] = "16384";
CONSTANTS["SITEADMIN_DEFAULT_SALES_ASSOCIATE"] = "4096";
CONSTANTS["SITEADMIN_ENABLE_ACCOUNT_ALERT_MANGEMENT"] = "32768";
CONSTANTS["SITEADMIN_ENABLE_AFFILIATE_DELETE"] = "32";
CONSTANTS["SITEADMIN_ENABLE_AFFILIATE_EDIT"] = "16";
CONSTANTS["SITEADMIN_ENABLE_COMPANY_DELETE"] = "8";
CONSTANTS["SITEADMIN_ENABLE_COMPANY_EDIT"] = "4";
CONSTANTS["SITEADMIN_ENABLE_COMPANY_EDIT_ADVANCED"] = "8192";
CONSTANTS["SITEADMIN_ENABLE_DASHBOARD"] = "1";
CONSTANTS["SITEADMIN_ENABLE_FINANCIAL_DATA"] = "256";
CONSTANTS["SITEADMIN_ENABLE_REMOTELOGIN"] = "128";
CONSTANTS["SITEADMIN_ENABLE_SITE_ACCOUNT_MANAGEMENT"] = "512";
CONSTANTS["SITEADMIN_ENABLE_SNAPSHOT"] = "2";
CONSTANTS["SITEADMIN_ENABLE_UTILITIES"] = "64";
CONSTANTS["SITEADMIN_LOGIN_TIMEOUT_MINUTES"] = "60";
CONSTANTS["SYSTEM_USER_ID"] = "0";
CONSTANTS["SYSTEM_USER_NAME"] = "SysAdmin";
CONSTANTS["THREAD_PREFIX_BACKGROUND_REPORTING"] = "BackgroundReporting_";
CONSTANTS["THREAD_PREFIX_EXPENSEQBOEXPORT"] = "ExpenseQBOExportPending_";
CONSTANTS["THREAD_PREFIX_GUSTOPAYROLLDELETE"] = "GustoPayrollDeletePending_";
CONSTANTS["THREAD_PREFIX_GUSTOPAYROLLSYNC"] = "GustoPayrollSyncPending_";
CONSTANTS["THREAD_PREFIX_HOURLYQBOEXPORT"] = "HourlyQBOExportPending_";
CONSTANTS["THREAD_PREFIX_PROJECTQBOEXPORT"] = "ProjectQBOExportPending_";
CONSTANTS["TIMECLASS_ALL"] = "1,2,3,4,5,6,7,8";
CONSTANTS["TIMECLASS_HOLIDAY"] = "5";
CONSTANTS["TIMECLASS_HOLIDAY_COLOR"] = "blue";
CONSTANTS["TIMECLASS_OTHER1"] = "6";
CONSTANTS["TIMECLASS_OTHER1_COLOR"] = "blue-bright";
CONSTANTS["TIMECLASS_OTHER2"] = "8";
CONSTANTS["TIMECLASS_OTHER2_COLOR"] = "charcoal";
CONSTANTS["TIMECLASS_PTO"] = "4";
CONSTANTS["TIMECLASS_PTO_COLOR"] = "purple-dark";
CONSTANTS["TIMECLASS_SALARIED"] = "7";
CONSTANTS["TIMECLASS_SALARIED_COLOR"] = "yellow";
CONSTANTS["TIMECLASS_SICK"] = "2";
CONSTANTS["TIMECLASS_SICK_COLOR"] = "red";
CONSTANTS["TIMECLASS_STANDARD"] = "1";
CONSTANTS["TIMECLASS_STANDARD_COLOR"] = "none";
CONSTANTS["TIMECLASS_TIMEOFF_GROUP"] = "2,3,4,5,6,8";
CONSTANTS["TIMECLASS_VACATION"] = "3";
CONSTANTS["TIMECLASS_VACATION_COLOR"] = "green";
CONSTANTS["TIMECLASS_WORKHOURS_GROUP"] = "1,7";
CONSTANTS["TIMELABEL_HOLIDAY"] = "Holiday";
CONSTANTS["TIMELABEL_HOLIDAY_ABBREV"] = "HOL";
CONSTANTS["TIMELABEL_OTHER1"] = "Other1";
CONSTANTS["TIMELABEL_OTHER1_ABBREV"] = "OR1";
CONSTANTS["TIMELABEL_OTHER2"] = "Other2";
CONSTANTS["TIMELABEL_OTHER2_ABBREV"] = "OR2";
CONSTANTS["TIMELABEL_PTO"] = "PTO";
CONSTANTS["TIMELABEL_PTO_ABBREV"] = "PTO";
CONSTANTS["TIMELABEL_SALARIED"] = "Unpayable/Salaried";
CONSTANTS["TIMELABEL_SALARIED_ABBREV"] = "UnP/SAL";
CONSTANTS["TIMELABEL_SICK"] = "Sick";
CONSTANTS["TIMELABEL_SICK_ABBREV"] = "SIC";
CONSTANTS["TIMELABEL_STANDARD"] = "Standard";
CONSTANTS["TIMELABEL_STANDARD_ABBREV"] = "STD";
CONSTANTS["TIMELABEL_VACATION"] = "Vacation";
CONSTANTS["TIMELABEL_VACATION_ABBREV"] = "VAC";
CONSTANTS["TIME_MASK_BASIC"] = "hh:mm tt";
CONSTANTS["TIME_MASK_BASIC2"] = "hh:mm:ss tt";
CONSTANTS["TIME_MASK_JSON"] = "HH:mm:ss";
CONSTANTS["TIME_ROUNDING_INCREMENTS"] = [
  "0",
  "3",
  "5",
  "6",
  "10",
  "12",
  "15"
];
CONSTANTS["TOKEN_MINUTES_ACCOUNT_ACTIVATION"] = "86400";
CONSTANTS["TOKEN_MINUTES_LOGIN_KEY"] = "30";
CONSTANTS["TOKEN_MINUTES_PASSWORD_RESET"] = "30";
CONSTANTS["TRIAL_PERIOD_DAYS"] = "15";
CONSTANTS["TRIAL_PERIOD_EXTENSION_DAYS"] = "7";
CONSTANTS["TUID_PLACEHOLDER"] = "00000000-0000-0000-0000-000000000000";
CONSTANTS["UNKNOWN_RECORD"] = "7";
CONSTANTS["USERACCESS_ADMIN"] = "ADMIN";
CONSTANTS["USERACCESS_AFFILIATE"] = "AFFILIATE";
CONSTANTS["USERACCESS_EMPLOYEE"] = "EMP";
CONSTANTS["USERACCESS_EMP_SUP_LIST"] = "EMP,SUPER";
CONSTANTS["USERACCESS_MGMT_LIST"] = "ADMIN,SUPER";
CONSTANTS["USERACCESS_SITEADMIN"] = "SITEADMIN";
CONSTANTS["USERACCESS_STAFF_LIST"] = "ADMIN,SUPER,EMP";
CONSTANTS["USERACCESS_SUPER"] = "SUPER";
CONSTANTS["USER_LOGIN_DISABLED"] = "64";
CONSTANTS["USER_LOGIN_TIMEOUT_MINUTES"] = "30";
CONSTANTS["USER_PASSWORD_RESET_TRIGGER"] = "3000-01-01 00:00:00";
CONSTANTS["USER_PERMISSION_NOT_USED_41"] = "2199023255552";
CONSTANTS["USER_PERMISSION_NOT_USED_42"] = "4398046511104";
CONSTANTS["USER_PERMISSION_NOT_USED_43"] = "8796093022208";
CONSTANTS["USER_PERMISSION_NOT_USED_44"] = "17592186044416";
CONSTANTS["USER_PERMISSION_NOT_USED_45"] = "35184372088832";
CONSTANTS["USER_PREFERENCE_ENABLE_LOGIN_LINKS"] = "1024";
CONSTANTS["USER_PREFERENCE_NO_MARKETING_CONTACT"] = "512";
CONSTANTS["USER_PREFERENCE_PAUSE_PROJECTTIMERS_ON_CLOCKOUT"] = "1";
CONSTANTS["USER_PREFERENCE_STOP_PROJECTTIMERS_ON_CLOCKOUT"] = "256";
CONSTANTS["USER_PREFERENCE_WEEKSTART_FRIDAY"] = "64";
CONSTANTS["USER_PREFERENCE_WEEKSTART_LIST"] = "2,4,8,16,32,64,128";
CONSTANTS["USER_PREFERENCE_WEEKSTART_MONDAY"] = "4";
CONSTANTS["USER_PREFERENCE_WEEKSTART_SATURDAY"] = "128";
CONSTANTS["USER_PREFERENCE_WEEKSTART_SUNDAY"] = "2";
CONSTANTS["USER_PREFERENCE_WEEKSTART_THURSDAY"] = "32";
CONSTANTS["USER_PREFERENCE_WEEKSTART_TUESDAY"] = "8";
CONSTANTS["USER_PREFERENCE_WEEKSTART_WEDNESDAY"] = "16";
CONSTANTS["USER_QUOTES_ACCESS"] = "1";
CONSTANTS["USER_SETTINGS_DISPLAY"] = "EMPSETTINGS";
CONSTANTS["USER_STATUS_ACTIVE"] = "1";
CONSTANTS["USER_STATUS_ALL"] = "0,1";
CONSTANTS["USER_STATUS_ARCHIVED"] = "0";
CONSTANTS["VENDORSTATUS_ACTIVE"] = "1";
CONSTANTS["VENDORSTATUS_ALL"] = "0,1";
CONSTANTS["VENDORSTATUS_ARCHIVED"] = "0";
CONSTANTS["WEEKLY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MAX"] = "168";
CONSTANTS["WEEKLY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MIN"] = "0.01";

CONST_GROUPS["ACCESS_TYPES"] = {
  USERACCESS_EMPLOYEE: "EMP",
  USERACCESS_STAFF_LIST: "ADMIN,SUPER,EMP",
  USERACCESS_SITEADMIN: "SITEADMIN",
  USERACCESS_SUPER: "SUPER",
  USERACCESS_EMP_SUP_LIST: "EMP,SUPER",
  USERACCESS_AFFILIATE: "AFFILIATE",
  USERACCESS_MGMT_LIST: "ADMIN,SUPER",
  USERACCESS_ADMIN: "ADMIN"
};
CONST_GROUPS["ACCOUNT_CODE_STATUSES"] = {
  ACCTCODESTATUS_ARCHIVED: "0",
  ACCTCODESTATUS_ALL: "0,1",
  ACCTCODESTATUS_ACTIVE: "1"
};
CONST_GROUPS["ACCOUNT_FEATURE_FLAGS"] = {
  ACF_ENABLE_QUOTES: "32"
};
CONST_GROUPS["ACCRUAL_RATES"] = {
  ACCRUALRATE_YEARLY: "5",
  ACCRUALRATE_DAILY: "1",
  ACCRUALRATE_ALLRATES: "0,1,2,3,4,5,6,7,8",
  ACCRUALRATE_ONEWEEK: "7",
  ACCRUALRATE_QUARTERLY: "8",
  ACCRUALADJUSTMENT_REDEEM: "3",
  ACCRUALADJUSTMENT_AUTOMATIC: "1",
  ACCRUALRATE_NONE: "0",
  ACCRUALRATE_FIRSTOFMONTH: "2",
  ACCRUALRATE_TWOWEEKS: "4",
  ACCRUALRATE_TWICEAMONTH: "3",
  ACCRUALRATE_BYHOUR: "6"
};
CONST_GROUPS["AFFILIATES"] = {
  AFFILIATESTATUS_DELETED: "0",
  AFFILIATESTATUS_ARCHIVED: "2",
  DEFAULT_COMMISSION_PERCENTAGE: "20",
  AFFILIATESTATUS_ACTIVE: "1",
  COMMISSION_PAYMENT_WAITING_PERIOD: "90",
  COMMISSION_PAYMENT_ACTIVE: "1",
  COMMISSION_PAYMENT_SUSPENDED: "0"
};
CONST_GROUPS["API_KEY_PERMISSIONS"] = {
  APIKEY_PERM_PUT: "4",
  APIKEY_PERM_POST: "2",
  APIKEY_PERM_ALL: "31",
  APIKEY_PERM_DELETE: "16",
  APIKEY_PERM_PATCH: "8",
  APIKEY_PERM_GET: "1"
};
CONST_GROUPS["AUTHORIZATION_TYPE"] = {
  AUTHORIZATION_TYPE_LIST: "0,1,2",
  AUTHORIZATION_TYPE_NONE: "0",
  AUTHORIZATION_TYPE_PASSWORD: "2",
  AUTHORIZATION_TYPE_PIN: "1"
};
CONST_GROUPS["AUTOMATIC_CLOCK_OUT_SETTINGS"] = {
  AUTOMATIC_CLOCKOUT_HOURS: "16",
  MAXIMUM_ONCLOCK_HOURS: "4320"
};
CONST_GROUPS["AUTOMATIC_DEDUCTION_SETTINGS"] = {
  AUTODEDUCT_TYPE_LIST: "0,1,2",
  AUTODEDUCT_ONETIME: "1",
  AUTODEDUCT_NONE: "0",
  AUTODEDUCT_EVERYTIME: "2"
};
CONST_GROUPS["AVAILABLE_APPLICATIONS"] = {
  PROJECTTRACKING_APP: "2",
  EXPENSEREPORTS_APP: "4",
  HRDOCUMENTS_APP: "8",
  DEFAULT_ENABLED_USER_APPS: "15",
  CALENDARS_APP: "16",
  HOURLYTRACKING_APP: "1"
};
CONST_GROUPS["CALENDAR_IDS"] = {
  CALENDAR_ID_HIREDATES: "HIREDATES",
  HR_CALENDAR_IDS: "REVIEWDATES,BIRTHDAYS,HIREDATES,TERMINATIONDATES",
  CALENDAR_ID_BIRTHDAYS: "BIRTHDAYS",
  CALENDAR_ID_USHOLIDAYS: "USHOLIDAYS",
  CALENDAR_ID_TERMINATIONDATES: "TERMINATIONDATES",
  CALENDAR_ID_REVIEWDATES: "REVIEWDATES",
  COMPANY_CALENDAR_IDS: "USHOLIDAYS,PAYROLLPERIODS",
  CALENDAR_ID_PAYROLLPERIODS: "PAYROLLPERIODS"
};
CONST_GROUPS["CALENDAR_SETTINGS"] = {
  CALENDAR_EVENT_STATUS_ALL: "0,1",
  CALENDAR_TYPE_PUBLIC: "1",
  CALENDAR_CATEGORY_HR: "HR",
  CALENDAR_STATUS_ALL: "1,0",
  CALENDAR_EVENT_PUBLISH_ALL: "1,0",
  CALENDAR_CATEGORY_REPORT: "REPORT",
  SCHEDULE_DATE_SELECTION_BY_DAY: "1",
  CALENDAR_TYPE_PRIVATE: "2",
  CALENDAR_CATEGORY_DEFAULT: "DEFAULT",
  CALENDAR_EVENT_STATUS_AVAILABLE: "0",
  CALENDAR_EVENT_NOT_PUBLISHED: "0",
  CALENDAR_STATUS_ACTIVE: "1",
  CALENDAR_CATEGORY_SCHEDULE: "SCHEDULE",
  SCHEDULE_LIST_DISPLAY_BY_HIER: "1",
  CALENDAR_TYPE_SHARED: "3",
  CALENDAR_PROPERTY_RESET_TRIGGER: "[RESET]",
  SCHEDULE_DATE_SELECTION_BY_WEEK: "2",
  CALENDAR_EVENT_STATUS_UNAVAILABLE: "1",
  CALENDAR_TYPE_ALL: "1,2,3",
  CALENDAR_CATEGORY_CUSTOM: "CUSTOM",
  CALENDAR_STATUS_ARCHIVED: "0",
  SCHEDULE_LIST_DISPLAY_BY_ALPHA: "2",
  CALENDAR_EVENT_PUBLISHED: "1"
};
CONST_GROUPS["CANCELLATION_REASONS"] = {
  CANCELLATION_DOESNTMEETNEEDS: "1",
  CANCELLATION_SITEPERFORMANCE: "7",
  CANCELLATION_PRICE: "4",
  CANCELLATION_NONEED: "3",
  CANCELLATION_COMPLEXITY: "5",
  CANCELLATION_DIFFICULTY: "6",
  CANCELLATION_SWITCHSERVICES: "8",
  CANCELLATION_OUTOFBUSINESS: "2"
};
CONST_GROUPS["CANCELLATION_TYPES"] = {
  CANCELLATIONTYPE_STANDARD: "1",
  CANCELLATIONTYPE_IMMEDIATE: "2"
};
CONST_GROUPS["CLIENT_SETTINGS"] = {
  CLIENT_SETTINGS_CONTROLS: {
    IS_NEW_ENROLLMENT: {
      null: "true",
      type: "boolean"
    }
  },
  CLIENT_SETTINGS_OPTIONS: {
    USER_SELECTION: [
      "supervisor",
      "alphabetical"
    ],
    WIDGET_TAB_EXPENSE: [
      "balances"
    ],
    MENU_MODE: [
      "standard",
      "icon"
    ],
    PDF_PRINT_OPTION_INCLUDE_LEGENDS: [
      "NONE",
      "ONE",
      "EVERY"
    ],
    PDF_PRINT_OPTION_INCLUDE_EXTENDED_DATA: [
      "true",
      "false"
    ],
    PROMPT_CLOCKOUT_WARNING: [
      "true",
      "false"
    ],
    PDF_PRINT_OPTION_INCLUDE_PAGE_BREAKS: [
      "true",
      "false"
    ],
    TABLE_SORTING: [
      "individual",
      "grouped"
    ],
    NUMBER_DISPLAY_FORMAT: [
      "decimal",
      "human"
    ],
    PDF_PRINT_OPTION_INCLUDE_SIGS: [
      "NONE",
      "ONE",
      "EVERY"
    ],
    ITEM_SELECTION: [
      "checkboxes",
      "lists"
    ],
    GUIDED_TOURS: [
      "show",
      "hide"
    ],
    PROMPT_CLOCKIN_WARNING: [
      "true",
      "false"
    ],
    PDF_PRINT_OPTION_PRINT_SIZE: [
      "0",
      "1",
      "2",
      "3",
      "4"
    ],
    USER_SELECTION_GROUPING: [
      "supervisor_full",
      "supervisor_indiv"
    ],
    ITEM_ORDERING: [
      "alphabetical",
      "mostrecent"
    ],
    WIDGET_TAB_HOURLY: [
      "balances",
      "payroll",
      "status"
    ],
    TABLE_DISPLAY: [
      "smallFormat",
      "mediumFormat",
      "regularFormat"
    ],
    LOGIN_LANDING_PAGE: [
      "Home",
      "Dashboard",
      "Timesheet",
      "MyExpenses",
      "TimeOffRequest",
      "Schedules",
      "MessageCenter",
      "Notifications",
      "AccountAlerts",
      "Memos",
      "MessageBoard"
    ],
    WIDGET_TAB_PROJECT: [
      "balances"
    ],
    MENU_DISPLAY: [
      "menuOpen",
      "menuClosed",
      "menuAutomatic"
    ],
    REPORT_HEADER_WRAPPING: [
      "true",
      "false"
    ]
  },
  LOGIN_LANDING_PAGES: {
    MyExpenses: "default.cfm?page=Timesheet&DisplayMode=EXPENSE",
    MessageBoard: "default.cfm?page=MessageCenter&SelectedTab=MessageBoard",
    Home: "default.cfm?page=Home",
    TimeOffRequest: "default.cfm?page=Home&SelectedTab=ManualEntry&DisplayMode=HOURLY",
    Notifications: "default.cfm?page=MessageCenter&SelectedTab=Notifications",
    MessageCenter: "default.cfm?page=MessageCenter",
    Memos: "default.cfm?page=MessageCenter&SelectedTab=Memos",
    AccountAlerts: "default.cfm?page=MessageCenter&SelectedTab=AccountAlerts",
    Timesheet: "default.cfm?page=Timesheet",
    Dashboard: "default.cfm?page=Dashboard",
    Schedules: "default.cfm?page=Schedules"
  }
};
CONST_GROUPS["COMPANY_BILLING_TYPES"] = {
  BILLINGTYPE_NONE: "0",
  BILLINGTYPE_MONTHLY: "1",
  BILLINGTYPE_FREE: "3",
  BILLINGTYPE_ANNUAL: "2",
  BILLINGTYPE_ALL: "0,1,2,3"
};
CONST_GROUPS["COMPANY_SALES_STATUSES"] = {
  COMPANY_SALESSTATUS_CLOSED: "3",
  COMPANY_SALESSTATUS_NONE: "0",
  COMPANY_SALESSTATUS_INTRIAL: "2",
  COMPANY_SALESSTATUS_PROJECT: "4",
  COMPANY_SALESSTATUS_GHOST: "6",
  COMPANY_SALESSTATUS_ALL: "0,1,2,3,4,5,6",
  COMPANY_SALESSTATUS_NOCONTACT: "5",
  COMPANY_SALESSTATUS_ROLLOUT: "1"
};
CONST_GROUPS["COMPANY_SETTINGS_FLAGS"] = {
  COMPANY_ENABLE_CUSTOMERS: "4294967296",
  COMPANY_SEND_PAYMENT_RECEIPT: "16",
  COMPANY_DISABLE_FUTURE_EXPENSE_ENTRY: "137438953472",
  COMPANY_ENABLE_PROJECT_EDIT: "128",
  COMPANY_DISABLE_FUTURE_PROJECT_ENTRY: "68719476736",
  COMPANY_DISABLE_FUTURE_HOURLY_ENTRY: "34359738368",
  COMPANY_SETTING_NOT_USED_40: "549755813888",
  COMPANY_PHOTO_VALIDATION_BY_FACE_DETECT: "32",
  COMPANY_SETTING_NOT_USED_41: "1099511627776",
  COMPANY_ENABLE_OTHER1: "16777216",
  DEFAULT_COMPANY_SETTINGS_FLAGS: "296570048237",
  COMPANY_ENABLE_HOURLY_DELETE: "8192",
  COMPANY_ENABLE_CLOCKTIME_EDIT: "131072",
  COMPANY_ENABLE_PROJECT_ENTRY: "2048",
  COMPANY_ENABLE_HOURLY_ENTRY: "1024",
  COMPANY_ENABLE_PROJECT_ENTRY_WITHOUT_ALERT: "64",
  COMPANY_ENABLE_PHOTO_SECURITY: "524288",
  COMPANY_ENABLE_HRREPORTS: "32768",
  COMPANY_ENABLE_PROJECT_DELETE: "16384",
  COMPANY_ENABLE_DIRECTORY: "1073741824",
  COMPANY_SETTING_NOT_USED_42: "2199023255552",
  COMPANY_ENABLE_ACCRUALS: "512",
  COMPANY_ENABLE_AUTOMATIC_CLOCKOUT: "262144",
  COMPANY_ENABLE_HOURLY_ENTRY_WITHOUT_ALERT: "2",
  COMPANY_ENABLE_CALENDARS: "274877906944",
  COMPANY_ENABLE_HOLIDAY: "8388608",
  COMPANY_ENABLE_PROJECT_DESCRIPTION_VIEW: "67108864",
  COMPANY_ENABLE_VACATION: "2097152",
  COMPANY_ENABLE_MESSAGE_BOARD: "134217728",
  COMPANY_ENABLE_PAID_BREAK: "268435456",
  COMPANY_ENABLE_HOURLY: "4",
  COMPANY_ENABLE_PASSWORDUPDATE: "536870912",
  COMPANY_ENABLE_PROJECT_SIMULTANEOUS_TIMERS: "8589934592",
  COMPANY_ENABLE_PTO: "4194304",
  COMPANY_ENABLE_EXPENSEREPORTS: "65536",
  COMPANY_ENABLE_EMPLOYEE_TIME_ZONE_ACCESS: "4096",
  COMPANY_ENABLE_PROJECT: "8",
  COMPANY_ENABLE_HOURLY_EDIT: "1",
  COMPANY_ENABLE_PROJECT_EDIT_WO_REASON: "2147483648",
  COMPANY_ENABLE_PROJECT_TIME_DEFAULT_BILLABLE: "17179869184",
  COMPANY_ENABLE_OTHER2: "33554432",
  COMPANY_ENABLE_HOURLY_EDIT_WO_REASON: "256",
  COMPANY_ENABLE_SICK: "1048576"
};
CONST_GROUPS["COMPANY_STATUSES"] = {
  COMPANYSTATUS_OTHER: "5",
  COMPANYSTATUS_DELINQUENT: "3",
  COMPANYSTATUS_NOT_USED: "6",
  COMPANYSTATUS_ALL: "1,2,3,4,5,6,7,8",
  COMPANYSTATUS_EXPIRED: "4",
  COMPANYSTATUS_ACTIVE: "2",
  COMPANYSTATUS_PENDINGREFERRAL: "7",
  COMPANYSTATUS_INTRIAL: "1",
  COMPANYSTATUS_CANCELED: "8"
};
CONST_GROUPS["CUSTOMER_STATUSES"] = {
  CUSTOMERSTATUS_ALL: "0,1",
  CUSTOMERSTATUS_ACTIVE: "1",
  CUSTOMERSTATUS_ARCHIVED: "0"
};
CONST_GROUPS["DEMO_ACCOUNT_SETTINGS"] = {
  TRIAL_PERIOD_DAYS: "15",
  TRIAL_PERIOD_EXTENSION_DAYS: "7"
};
CONST_GROUPS["EMAIL_PREFERENCES"] = {
  EMAIL_CLOCKOUT_REMINDER: "8",
  EMAIL_STATUSREPORT_MONTHLY: "4",
  EMAIL_NEW_HOURLY_ALERTS: "16",
  EMAIL_STATUSREPORT_WEEKLY: "2",
  EMAIL_NEW_PROJECT_ALERTS: "32",
  EMAIL_STATUSREPORT_DAILY: "1",
  EMAIL_STATUSREPORT_LIST: "1,2,4"
};
CONST_GROUPS["EMPLOYEE_TYPES"] = {
  EMPLOYEETYPE_CONTRACTOR: "2",
  EMPLOYEETYPE_STUDENT: "4",
  EMPLOYEETYPE_VOLUNTEER: "3",
  EMPLOYEETYPE_EMP: "1",
  EMPLOYEETYPE_OTHER: "5"
};
CONST_GROUPS["ERROR_CODES"] = {
  ERROR_GENERAL_COMPANYID_NOT_FOUND: "100009",
  ERROR_GENERAL_IDEMPOTENCY_TOKEN_INVALID: "100001",
  ERROR_LIST_EVENTID_INVALID: "300005",
  ERROR_CLOCK_PAID_BREAK_NOT_ENABLED: "200013",
  ERROR_CLOCK_IP_ADDRESS_INVALID: "200006",
  ERROR_CLOCK_SHIFT_EDIT_LATER_THAN_CURRENT: "200003",
  ERROR_CLOCK_TIME_EDIT_DISABLED: "200009",
  ERROR_GENERAL_PROJECT_TRACKING_NOT_ENABLED: "100006",
  ERROR_GENERAL_USERID_NOT_FOUND: "100003",
  ERROR_CLOCK_SHIFT_EDIT_LATER_THAN_CLOCK_OUT: "200004",
  ERROR_GENERAL_NO_PERMISSION_FOR_ACTION: "100008",
  ERROR_LIST_PROJECTID_INVALID: "300002",
  ERROR_GENERAL_DUPLICATE_REQUEST: "100002",
  ERROR_GENERAL_COMPANY_USER_MISMATCH: "100010",
  ERROR_CLOCK_EDIT_REASON_REQUIRED: "200011",
  ERROR_CLOCK_PHOTO_REQUIRED: "200008",
  ERROR_CLOCK_CLOCK_OUT_LATER_THAN_CLOCK_IN: "200015",
  ERROR_GENERAL_ACCOUNT_AUTHORIZATION_FAILED: "100004",
  ERROR_CLOCK_USER_NOT_CLOCKED_IN: "200001",
  ERROR_LIST_VENDORID_INVALID: "300004",
  ERROR_CLOCK_CLOCK_OUT_INTERFERES_WITH_PAID_BREAK: "200016",
  ERROR_LIST_CUSTOMERID_INVALID: "300001",
  ERROR_CLOCK_GEOLOCATION_REQUIRED: "200005",
  ERROR_LIST_ACCOUNTCODEID_INVALID: "300003",
  ERROR_CLOCK_EDIT_REASON_TOO_SHORT: "200012",
  ERROR_CLOCK_TIME_ARGUMENT_CONFLICT: "200017",
  ERROR_GENERAL_EXPENSE_TRACKING_NOT_ENABLED: "100007",
  ERROR_CLOCK_USER_CLOCKED_IN: "200002",
  ERROR_CLOCK_SHIFT_RESTRICTED: "200007",
  ERROR_CLOCK_TIME_VALUE_INVALID: "200010",
  ERROR_CLOCK_PAID_BREAK_ALREADY_TAKEN: "200014",
  ERROR_GENERAL_HOURLY_TRACKING_NOT_ENABLED: "100005"
};
CONST_GROUPS["EVENT_STATUSES"] = {
  EVENTSTATUS_ACTIVE: "1",
  EVENTSTATUS_ARCHIVED: "0",
  EVENTSTATUS_ALL: "0,1"
};
CONST_GROUPS["EXPENSE_STATUSES"] = {
  EXPENSERECORDSTATUS_ALL: "0,1",
  EXPENSERECORDSTATUS_RECONCILED: "1",
  EXPENSERECORDSTATUS_OPEN: "0"
};
CONST_GROUPS["FORMATTING_MASKS"] = {
  DATE_DAY_ABBREV: "DDD",
  DATE_MASK_YYYYMMDD_ISO: "yyyy-mm-dd",
  DATE_MASK_EXTENDED: "ddd, mmm dd, yyyy",
  TIME_MASK_BASIC2: "hh:mm:ss tt",
  DATE_MASK_EXTENDED2: "dddd mmm dd yyyy",
  DATE_MASK_SHORT: "mmm dd",
  TIME_MASK_JSON: "HH:mm:ss",
  DATE_MASK_JSON: "mmmm, dd yyyy",
  LOCATION_COORDS_PERMISSION_ERROR: "999.99999,999.99999:99999",
  DATE_MASK_MMDDYYYY_DASH: "mm-dd-yyyy",
  NUM_MASK_2D: ".00",
  DATE_MASK_DDMMYYYY_DASH: "dd-mm-yyyy",
  DATE_MASK_YYYYMMDD_SLASH: "yyyy/mm/dd",
  DATE_MASK_BASIC: "mmm dd, yyyy",
  NUM_MASK_3D: ".000",
  TUID_PLACEHOLDER: "00000000-0000-0000-0000-000000000000",
  DATE_MASK_MMDDYYYY_SLASH: "mm/dd/yyyy",
  NUM_MASK_5D: ".00000",
  DATE_MASK_SHORT2: "mmm yyyy",
  LOCATION_COORDS_UNAVAILABLE: "000.00000,000.00000:00000",
  TIME_MASK_BASIC: "hh:mm tt",
  DATE_MASK_EXTENDED3: "dddd mmmm dd yyyy",
  DATE_MASK_DDMMYYYY_SLASH: "dd/mm/yyyy"
};
CONST_GROUPS["GUSTO_PAYROLL_SYNC"] = {
  GUSTO_ON_UNMATCHED_FAIL: "fail",
  GUSTO_ON_UNMATCHED_WARN: "warn"
};
CONST_GROUPS["HOURLY_RECORD_STATUSES"] = {
  HOURLYRECORDSTATUS_REPORT_DEFAULT: "0,1,3",
  HOURLYRECORDSTATUS_SPLITPAID: "2",
  HOURLYRECORDSTATUS_PAID: "1",
  HOURLYRECORDSTATUS_ARCHIVED: "3",
  HOURLYRECORDSTATUS_ALL: "0,1,2,3",
  HOURLYRECORDSTATUS_OPEN: "0",
  HOURLYRECORDSTATUS_OPEN_PAID_LIST: "0,1",
  HOURLYRECORDSTATUS_SPLITPAID_PAID: "22",
  HOURLYRECORDSTATUS_SPLITPAID_OPEN: "21"
};
CONST_GROUPS["HR_SETTINGS"] = {
  HRREPORT_TERMINATION_ARCHIVED: "6",
  HRREPORT_PERFORMANCEREVIEW: "1",
  HRREPORT_INCIDENT: "5",
  HRREPORT_TERMINATION: "4",
  PERFORMANCEREVIEW_MONTHLY: "1",
  PERFORMANCEREVIEW_WEEKLY: "5",
  PERFORMANCEREVIEW_QUARTERLY: "2",
  HRREPORT_DISCIPLINE: "3",
  HRREPORT_ALL: "1,2,3,4,5,6",
  PERFORMANCEREVIEW_SEMIANNUAL: "3",
  PERFORMANCEREVIEW_UNSCHEDULED: "6",
  PERFORMANCEREVIEW_GROUP: "1,2,3,4,5,6",
  PERFORMANCEREVIEW_ANNUAL: "4",
  HRREPORT_COMMENDATION: "2"
};
CONST_GROUPS["LOGIN_CODES"] = {
  LOGIN_TOO_MANY_ATTEMPTS: "2",
  LOGIN_SUCCESSFUL: "0",
  LOGIN_EMPTY_CREDENTIALS: "5",
  LOGIN_DISABLED: "3",
  LOGIN_INVALID_USERNAME_PASSWORD: "1",
  LOGIN_INVALID_KEY: "4",
  LOGIN_UNKNOWN: "-1"
};
CONST_GROUPS["MAX_ROWS"] = {
  MAX_ROWS_OPTIONS: [
    {
      display: "1 (debug)",
      value: "1",
      debugOnly: true
    },
    {
      display: "3 (debug)",
      value: "3",
      debugOnly: true
    },
    {
      display: "5 (debug)",
      value: "5",
      debugOnly: true
    },
    {
      display: "10",
      value: "10",
      debugOnly: false
    },
    {
      display: "20",
      value: "20",
      debugOnly: false
    },
    {
      display: "40",
      value: "40",
      debugOnly: false
    },
    {
      display: "80",
      value: "80",
      debugOnly: false
    },
    {
      display: "120",
      value: "120",
      debugOnly: false
    },
    {
      display: "160",
      value: "160",
      debugOnly: false
    },
    {
      display: "200",
      value: "200",
      debugOnly: false
    }
  ]
};
CONST_GROUPS["MISC_TEXT"] = {
  DEFAULT_SIGNATURE_TEXT: "By signing above I acknowledge and certify that the information contained on this document is true and accurate."
};
CONST_GROUPS["NOTE_STATUSES"] = {
  NOTE_STATUS_ANY: "0,1",
  NOTE_STATUS_OPEN: "1",
  NOTE_STATUS_CLOSED: "0"
};
CONST_GROUPS["NOTE_TYPES"] = {
  NOTE_TYPE_INCIDENT: "10",
  NOTE_TYPE_CUSTOMER_SUGGESTION: "8",
  NOTE_TYPE_GROUP_READMEOROPEN: "103",
  NOTE_TYPE_GROUP_ALL: "102",
  NOTE_TYPE_README: "2",
  NOTE_TYPE_RETENTION: "1",
  NOTE_TYPE_CUSTOMER_COMMENT: "4",
  NOTE_TYPE_BILLING_RELATED: "5",
  NOTE_TYPE_ANY: "0,1,2,3,4,5,6,7,8,9,10,11",
  NOTE_TYPE_GROUP_ANYOPEN: "104",
  NOTE_TYPE_SPECIAL_OFFER: "3",
  NOTE_TYPE_BUG_REPORT: "6",
  NOTE_TYPE_GENERAL: "0",
  NOTE_TYPE_GROUP_CUSTSRV: "101",
  NOTE_TYPE_NO_SALE: "11",
  NOTE_TYPE_TRIAL_COMMENT: "9",
  NOTE_TYPE_ABOUT: "7"
};
CONST_GROUPS["NOTIFICATIONS"] = {
  NOTIFICATION_EMPLOYEE_AUTOMATIC_CLOCKOUT_PERSONAL: "7",
  NOTIFICATION_EMPLOYEE_CLOCKOUT_SHIFT_EXCEEDED: "6",
  NOTIFICATION_LAST_DAY_OF_PAY_PERIOD: "9",
  NOTIFICATION_EMPLOYEE_CLOCKOUT: "1",
  NOTIFICATION_EMPLOYEE_AUTOMATIC_CLOCKOUT_SUPERVISOR: "8",
  NOTIFICATION_EMPLOYEE_CLOCKIN: "5",
  NOTIFICATION_EMPLOYEE_ELECTIVE_ACTION: "11",
  NOTIFICATION_CLOCKOUT_LINK: "4",
  NOTIFICATION_PROJECT_ALERT_CREATED: "3",
  NOTIFICATION_HOURLY_ALERT_CREATED: "2",
  NOTIFICATION_STILL_ON_CLOCK_REMINDER: "10"
};
CONST_GROUPS["OVERTIME_SETTINGS"] = {
  WEEKLY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MAX: "168",
  MINIMUM_HOURS_FOR_DAILY_OT_MAX: "24",
  OVERTIME_WEEKLY: "2",
  MINIMUM_HOURS_FOR_DAILY_DOUBLETIME_MIN: "0.01",
  MINIMUM_HOURS_FOR_DAILY_DOUBLETIME_MAX: "24",
  OVERTIME_LIST: "1,2,3",
  MINIMUM_HOURS_FOR_WEEKLY_OT_MIN: "0.01",
  DAILY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MAX: "24",
  MINIMUM_HOURS_FOR_DAILY_WEEK_OT_MAX: "168",
  OVERTIME_DAILY: "3",
  MINIMUM_HOURS_FOR_DAILY_OT_MIN: "0.01",
  OVERTIME_NONE: "1",
  DAILY_OVERTIME_HOURS_REQUIRED_FOR_7TH_DAY_DOUBLETIME_MAX: "24",
  WEEKLY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MIN: "0.01",
  MINIMUM_HOURS_FOR_WEEKLY_OT_MAX: "168",
  MINIMUM_HOURS_FOR_DAILY_WEEK_OT_MIN: "0.01",
  DAILY_HOURS_REQUIRED_FOR_7TH_DAY_OT_MIN: "0.01",
  MINIMUM_QUALIFYING_DAYS_FOR_7TH_DAY_OT_LIST: "6,7",
  DAILY_OVERTIME_HOURS_REQUIRED_FOR_7TH_DAY_DOUBLETIME_MIN: "0.01"
};
CONST_GROUPS["PAYMENT_ACTIONS"] = {
  PAYMENTUPDATE_NONE: "0",
  PAYMENTUPDATE_ALL: "0,1,2",
  PAYMENTUPDATE_PROFILE: "1",
  PAYMENTUPDATE_BILLINGDATE: "2"
};
CONST_GROUPS["PAYMENT_SETTINGS"] = {
  MIN_DAYS_FOR_BILLING_PRORATE: "3"
};
CONST_GROUPS["PAYMENT_SYSTEMS"] = {
  PAYMENTSYSTEM_PAYPAL: "1",
  PAYMENTSYSTEM_MANUAL: "3",
  PAYMENTSYSTEM_ALL: "1,2,3",
  PAYMENTSYSTEM_STRIPE: "2"
};
CONST_GROUPS["PAYMENT_TYPES"] = {
  PAYMENTTYPE_ACTIVATION: "1",
  PAYMENTTYPE_UPDATE: "3",
  PAYMENTTYPE_CANCELLATION: "4",
  PAYMENTTYPE_REACTIVATION: "5",
  PAYMENTTYPE_MODIFY: "2"
};
CONST_GROUPS["PAYROLL_CODES"] = {
  PAYROLL_CODE_PROCESSED: "0",
  PAYROLL_GUSTO_SYNC_USER_STATUS_NOT_RUN: "1",
  PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER_NAME: "100007",
  PAYROLL_CODE_INVALID_ACCRUAL_SETTINGS_FOR_USER: "23",
  PAYROLL_CODE_INVALID_APPEND_PAYROLLID: "16",
  PAYROLL_GUSTO_SYNC_NO_UNPROCESSED_PAYROLLS: "100001",
  PAYROLL_CODE_FLSA_INVALID_TIME_RECORD: "25",
  PAYROLL_CODE_SALARIED_SPLITPAID_RECORDS_EXISTS: "14",
  PAYROLL_CODE_DUPLICATE_USERS_FOUND: "10",
  PAYROLL_CODE_OVERLAPPING_PERIODS: "5",
  PAYROLL_CODE_ALERTS_EXIST: "7",
  PAYROLL_CODE_NO_USERS_INCLUDED: "11",
  PAYROLL_CODE_PROCESS_VALIDATION_ERROR: "8",
  PAYROLL_CODE_USERS_HAVE_POSTDATED_PAYROLL: "18",
  PAYROLL_GUSTO_SYNC_USER_STATUS_NOT_APPLICABLE: "3",
  PAYROLL_CODE_INVALID_DATES: "3",
  PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER_ID: "100006",
  PAYROLL_GUSTO_SYNC_USER_BLOCKED_UNMATCHED: "5",
  PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_PERIOD: "100003",
  PAYROLL_CODE_USERS_ALREADY_EXIST_IN_PAYROLL: "17",
  PAYROLL_CODE_NONSEQUENTIAL_RECORDS: "22",
  PAYROLL_CODE_UNPAID_RECORDS_EXISTS: "12",
  PAYROLL_CODE_LOCKED: "2",
  PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_DELETE_ALL: "3",
  PAYROLL_GUSTO_SYNC_CONNECTION_ERROR: "999999",
  PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_SYNC: "1",
  PAYROLL_CODE_INVALID_TIME_ZONE_FOR_PERIOD: "21",
  PAYROLL_CODE_INVALID_PAYROLLID: "19",
  PAYROLL_CODE_RECORDS_EXCEED_MAX_THRESHOLD: "24",
  PAYROLL_CODE_OVERLAPPING_RECORDS: "6",
  PAYROLL_CODE_STANDARD_SPLITPAID_RECORDS_EXISTS: "13",
  PAYROLL_CODE_PROCESS_VALIDATION_FAILED: "9",
  PAYROLL_CODE_INVALID_RUNBYID: "15",
  PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_USER: "100005",
  PAYROLL_GUSTO_SYNC_INVALID_PAYROLL_ID: "100004",
  PAYROLL_GUSTO_SYNC_MULTIPLE_UNPROCESSED_PAYROLLS: "100002",
  PAYROLL_GUSTO_SYNC_USER_SKIPPED_UNMATCHED: "4",
  PAYROLL_GUSTO_SYNC_USER_STATUS_SYNCED: "2",
  PAYROLL_CODE_SUMMARY_ONLY: "1",
  PAYROLL_CODE_INVALID_PARTIAL_USER_DELETE: "20",
  PAYROLL_CODE_FLSA_CHRONOLOGICAL_ORDER_VIOLATION: "26",
  PAYROLL_GUSTO_SYNC_USER_FAILED: "6",
  PAYROLL_CODE_NO_RECORDS_FOUND: "4",
  PAYROLL_GUSTO_BACKGROUND_JOB_TYPE_DELETE_PERIOD: "2",
  PAYROLL_GUSTO_BACKGROUND_JOB_STALE_MINUTES: "120"
};
CONST_GROUPS["PAYROLL_PERIODS"] = {
  PAYPERIOD_BIWEEKLY: "2",
  PAYPERIOD_ANY: "0,1,2,3,4",
  PAYPERIOD_NONE: "0",
  PAYPERIOD_SCHEDULED_LIST: "1,2,3,4",
  PAYPERIOD_BIMONTHLY: "4",
  PAYPERIOD_WEEKLY: "1",
  PAYPERIOD_MONTHLY: "3"
};
CONST_GROUPS["PAYROLL_SETTINGS"] = {
  PAYROLLCUSTOMERSTATUS_ALL: "0,1,2,3",
  PAYROLLCUSTOMERSTATUS_LOSTLEAD: "3",
  PAYROLL_ACTION_WARNING: "WARNING",
  PAYROLLCUSTOMERSTATUS_INACTIVE: "0",
  PAYROLLCUSTOMERSTATUS_LEAD: "2",
  PAYROLL_ACTION_ALL: "IGNORE,ERROR,WARNING",
  PAYROLL_ACTION_IGNORE: "IGNORE",
  PAYROLLCUSTOMERSTATUS_ACTIVE: "1",
  PAYROLL_ACTION_ERROR: "ERROR",
  PAYROLL_MULTITHREAD_THRESHOLD: "25"
};
CONST_GROUPS["PROJECT_RECORD_STATUSES"] = {
  PROJECTRECORDSTATUS_ALL: "0,1",
  PROJECTRECORDSTATUS_ACTIVE: "0",
  PROJECTRECORDSTATUS_ARCHIVED: "1"
};
CONST_GROUPS["PROJECT_STATUSES"] = {
  PROJECTSTATUS_ACTIVE: "1",
  PROJECTSTATUS_ARCHIVED: "0",
  PROJECTSTATUS_ALL: "0,1"
};
CONST_GROUPS["PROMO_CODES"] = {
  PROMOCODE_DISCOUNT_IN_PERP: "3",
  PROMOCODE_DISCOUNT: "2",
  PROMOCODE_ALL: "1,2,3",
  PROMOCODE_FREETERM: "1"
};
CONST_GROUPS["QUOTES"] = {
  QUOTE_STATUS_REVISION_ARCHIVED: "6",
  QUOTE_STATUS_REVISION_APPROVED: "3",
  QUOTE_RECURRING_WEEKLY: "1",
  QUOTE_MANUAL_ACTION_REVISION_REQUESTED: "3",
  QUOTE_STATUS_REJECTED: "4",
  QUOTE_STATUS_EXPIRED: "5",
  QUOTE_ALL: "0,1",
  QUOTE_STATUS_REVISION_ALL: "0,1,2,3,4,5,6,7",
  QUOTE_STATUS_ALL: "0,1,2,3,4,5,6,7",
  QUOTE_ITEM_DESCRIPTION_MAX_LENGTH: "2000",
  QUOTE_STATUS_REVISION_DRAFT: "1",
  QUOTE_RECURRING_BIWEEKLY: "2",
  QUOTE_CLIENT_ACTION_ACCEPTED: "1",
  QUOTE_CLIENT_ACTION_UNKNOWN: "0",
  QUOTE_STATUS_APPROVED: "3",
  QUOTE_STATUS_REVISION_UNKNOWN: "0",
  QUOTE_CLIENT_ACTION_REJECTED: "2",
  QUOTE_STATUS_REVISION_LOCKED: "7",
  QUOTE_ARCHIVED: "1",
  QUOTE_RECURRING_ANNUALLY: "7",
  QUOTE_STATUS_REQUESTED: "2",
  QUOTE_RECURRING_MONTHLY: "4",
  QUOTE_CLIENT_ACTION_ALL: "0,1,2,3",
  QUOTE_RECURRING_ALL: "0,1,2,3,4,5,6,7",
  QUOTE_MANUAL_ACTION_ACCEPTED: "1",
  QUOTE_STATUS_NEW: "7",
  QUOTE_STATUS_REVISION_EXPIRED: "5",
  QUOTE_STATUS_ARCHIVED: "6",
  QUOTE_RECURRING_QUARTERLY: "5",
  QUOTE_STATUS_REVISION_REQUESTED: "2",
  QUOTE_STATUS_UNKNOWN: "0",
  QUOTE_RECURRING_SEMIANNUALLY: "6",
  QUOTE_CLIENT_ACTION_REVISION_REQUESTED: "3",
  QUOTE_MANUAL_ACTION_ALL: "1,2,3",
  QUOTE_ACTIVE: "0",
  QUOTE_RECURRING_NONE: "0",
  QUOTE_RECURRING_SEMIMONTHLY: "3",
  QUOTE_STATUS_REVISION_REJECTED: "4",
  QUOTE_STATUS_DRAFT: "1",
  QUOTE_MANUAL_ACTION_DECLINED: "2"
};
CONST_GROUPS["QUOTE_TRACKING_FLAGS"] = {
  QTF_ENABLE_QUOTES: "1"
};
CONST_GROUPS["RECORD_APPROVED_STATUSES"] = {
  RECORD_APPROVED_STATUS_ALL: "0,1,2",
  RECORD_APPROVED_UNAPPROVED_LIST: "0,1",
  RECORD_UNAPPROVED: "0",
  RECORD_APPROVED: "1",
  RECORD_ALERT: "2"
};
CONST_GROUPS["RECORD_BILLABLE_STATUSES"] = {
  RECORD_UNBILLABLE: "0",
  RECORD_BILLABLE: "1",
  RECORD_BILLABLE_ALL: "0,1"
};
CONST_GROUPS["RECORD_FLAGGED_STATUSES"] = {
  FLAGGED_FOR_ALL: "3",
  FLAGGED_FOR_EMPLOYEE: "1",
  FLAGGED_FOR_SUPERVISOR: "2",
  NOT_FLAGGED: "0"
};
CONST_GROUPS["RECORD_ORIGINATION_TYPES"] = {
  ORIGINATION_TYPE_UNKNOWN: "0",
  ORIGINATION_TYPE_CLOCK_KIOSK: "7",
  ORIGINATION_TYPE_CLOCK_MOBILE: "2",
  ORIGINATION_TYPE_TIME_ENTRY_MOBILE: "4",
  ORIGINATION_TYPE_TIMER_MOBILE: "6",
  ORIGINATION_TYPE_TIMER: "5",
  ORIGINATION_TYPE_CLOCK: "1",
  ORIGINATION_TYPE_IMPORT: "8",
  ORIGINATION_TYPE_TIME_ENTRY: "3"
};
CONST_GROUPS["RECORD_SIGNED_STATUSES"] = {
  RECORD_SIGNED_ALL: "0,1",
  RECORD_UNSIGNED: "0",
  RECORD_SIGNED: "1"
};
CONST_GROUPS["RECORD_TYPES"] = {
  HOURLY_RECORD: "1",
  UNKNOWN_RECORD: "7",
  PAYROLL_RECORD_TYPE_TIME_SHEET: "1",
  PROJECT_RECORD: "4",
  HOURLY_STD_RECORD: "2",
  PAYROLL_RECORD_TYPE_UNKNOWN: "0",
  PROJECT_TIMER_RECORD: "5",
  HOURLY_NSTD_RECORD: "3",
  PAYROLL_RECORD_TYPE_PTO: "2",
  EXPENSE_RECORD: "6",
  PAYROLL_RECORD_TYPE_ALL: "0,1,2"
};
CONST_GROUPS["REFERRAL_METHODS"] = {
  REFERRALMETHOD_APA: "19",
  REFERRALMETHOD_PRINTAD: "9",
  REFERRALMETHOD_RESELLER: "12",
  REFERRALMETHOD_FACEBOOK: "18",
  REFERRALMETHOD_BUYERZONE: "4",
  REFERRALMETHOD_SALESFORCE: "11",
  REFERRALMETHOD_PAYROLLCOMPANY: "6",
  REFERRALMETHOD_APPLE: "5",
  REFERRALMETHOD_OTHER: "15",
  REFERRALMETHOD_TELEPHONE: "13",
  REFERRALMETHOD_WORDOFMOUTH: "7",
  REFERRALMETHOD_CUSTOMER: "2",
  REFERRALMETHOD_INCDOTCOM: "8",
  REFERRALMETHOD_NOTSPECIFIED: "0",
  REFERRALMETHOD_ADOBE: "16",
  REFERRALMETHOD_BLOG: "14",
  REFERRALMETHOD_ALL: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19",
  REFERRALMETHOD_SEARCHENGINE: "3",
  REFERRALMETHOD_AFFILIATE: "1",
  REFERRALMETHOD_TVRADIO: "10",
  REFERRALMETHOD_LINKEDIN: "17"
};
CONST_GROUPS["REPORT_TYPES"] = {
  REPORT_TYPE_ALL: "1,2,3",
  REPORT_TYPE_PROJECT: "2",
  REPORT_TYPE_HOURLY: "1",
  REPORT_TYPE_EXPENSE: "3"
};
CONST_GROUPS["SECURITY_SETTINGS"] = {
  FINGERPRINTSTATUS_ACTIVE_ENABLED: "1",
  PHOTOSECURITYSTATUS_ACTIVE: "1",
  FACIAL_DETECTION_CONFIDENCE_THRESHOLD: "95",
  PHOTOSECURITYSTATUS_INACTIVE: "0",
  FINGERPRINTSTATUS_INACTIVE: "0"
};
CONST_GROUPS["SESSION_TIMEOUT"] = {
  SESSION_TIMEOUT_LIST: "0,5,20,30,60,21",
  SESSION_TIMEOUT_30SEC: "30",
  SESSION_TIMEOUT_21DAY: "21",
  SESSION_TIMEOUT_60MIN: "60",
  SESSION_TIMEOUT_20MIN: "20",
  SESSION_TIMEOUT_5MIN: "5",
  SESSION_TIMEOUT_7DAY: "0"
};
CONST_GROUPS["SITE_ADMIN_PRIVILEGES"] = {
  SITEADMIN_ENABLE_SNAPSHOT: "2",
  SITEADMIN_ENABLE_COMPANY_EDIT_ADVANCED: "8192",
  SITEADMIN_ENABLE_DASHBOARD: "1",
  SITEADMIN_ENABLE_ACCOUNT_ALERT_MANGEMENT: "32768",
  SITEADMIN_ENABLE_REMOTELOGIN: "128",
  SITEADMIN_ENABLE_COMPANY_EDIT: "4",
  SITEADMIN_ENABLE_AFFILIATE_DELETE: "32",
  SITEADMIN_ENABLE_AFFILIATE_EDIT: "16",
  SITEADMIN_DEFAULT_REFERRAL_MANAGER: "16384",
  SITEADMIN_ENABLE_FINANCIAL_DATA: "256",
  SITEADMIN_ENABLE_COMPANY_DELETE: "8",
  SITEADMIN_ENABLE_UTILITIES: "64",
  SITEADMIN_ACCESS_RESTRICTED_NOTIFICATIONS: "1024",
  SITEADMIN_ENABLE_SITE_ACCOUNT_MANAGEMENT: "512",
  SITEADMIN_DEFAULT_SALES_ASSOCIATE: "4096",
  SITEADMIN_CLEAR_COMPANY_SEARCHFORM_ON_SUBMIT: "2048"
};
CONST_GROUPS["SITE_CONSTANTS"] = {
  DEFAULT_NOTIFICATION_SENT_BY: "Timesheets.com",
  COMPTIME_ACCRUAL_MULTIPLIERS: "1.00,1.25,1.50,1.75,2.00",
  MAX_USERS_PER_IMPORT: "75",
  SYSTEM_USER_NAME: "SysAdmin",
  IMAGE_EXPENSE_MAXSIZE: "1600x1600",
  SALES_ASSOCIATE_ASSIGNMENT_BY_LEAST_BUSY: "LEAST_BUSY",
  MESSAGE_CENTER_NOTIFICATION_KEY_DELIMITER: "~",
  MESSAGE_BOARD_MAX_MSG_LENGTH: "5000",
  IMAGE_THUMBNAIL_MAXSIZE: "320x320",
  SALES_ASSOCIATE_ASSIGNMENT_BY_USER_TIER: "USER_TIER",
  TOKEN_MINUTES_LOGIN_KEY: "30",
  MEMO_MAX_LENGTH: "10000",
  MAX_ITEM_IMPORT_PER_PERIOD: "1500",
  DEFAULT_ACCOUNT_ALERT_SENT_BY: "Timesheets.com",
  TIME_ROUNDING_INCREMENTS: [
    "0",
    "3",
    "5",
    "6",
    "10",
    "12",
    "15"
  ],
  TOKEN_MINUTES_PASSWORD_RESET: "30",
  PROJECT_MINIMUM_INCREMENTS: [
    "0",
    "6",
    "8",
    "10",
    "15",
    "20",
    "30",
    "60"
  ],
  TOKEN_MINUTES_ACCOUNT_ACTIVATION: "86400",
  IMAGE_BRANDLOGO_MAXSIZE: "280x100",
  PAID_BREAK_DURATIONS: [
    "0",
    "10",
    "15",
    "20",
    "30",
    "60"
  ],
  MAX_PROJECT_RECORDS_PER_IMPORT: "1000",
  MIN_LENGTH_FOR_EDIT_REASON: "6",
  SYSTEM_USER_ID: "0",
  DOWNLOAD_FILE_EXPIRATION: "2592000",
  MAX_HOURLY_RECORDS_PER_IMPORT: "1000"
};
CONST_GROUPS["THREAD_PREFIXES"] = {
  THREAD_PREFIX_HOURLYQBOEXPORT: "HourlyQBOExportPending_",
  THREAD_PREFIX_PROJECTQBOEXPORT: "ProjectQBOExportPending_",
  THREAD_PREFIX_GUSTOPAYROLLSYNC: "GustoPayrollSyncPending_",
  THREAD_PREFIX_EXPENSEQBOEXPORT: "ExpenseQBOExportPending_",
  THREAD_PREFIX_GUSTOPAYROLLDELETE: "GustoPayrollDeletePending_",
  THREAD_PREFIX_BACKGROUND_REPORTING: "BackgroundReporting_"
};
CONST_GROUPS["TIMECLASS_LABELS"] = {
  TIMELABEL_PTO: "PTO",
  TIMELABEL_STANDARD_ABBREV: "STD",
  TIMELABEL_OTHER1: "Other1",
  TIMELABEL_HOLIDAY_ABBREV: "HOL",
  TIMELABEL_HOLIDAY: "Holiday",
  TIMELABEL_PTO_ABBREV: "PTO",
  TIMELABEL_SALARIED: "Unpayable/Salaried",
  TIMELABEL_VACATION_ABBREV: "VAC",
  TIMELABEL_SALARIED_ABBREV: "UnP/SAL",
  TIMELABEL_OTHER2: "Other2",
  TIMELABEL_SICK: "Sick",
  TIMELABEL_SICK_ABBREV: "SIC",
  TIMELABEL_STANDARD: "Standard",
  TIMELABEL_OTHER2_ABBREV: "OR2",
  TIMELABEL_VACATION: "Vacation",
  TIMELABEL_OTHER1_ABBREV: "OR1"
};
CONST_GROUPS["TIME_CLASSES"] = {
  TIMECLASS_VACATION: "3",
  TIMECLASS_OTHER2_COLOR: "charcoal",
  TIMECLASS_OTHER1_COLOR: "blue-bright",
  TIMECLASS_WORKHOURS_GROUP: "1,7",
  TIMECLASS_SICK: "2",
  TIMECLASS_OTHER2: "8",
  TIMECLASS_TIMEOFF_GROUP: "2,3,4,5,6,8",
  TIMECLASS_VACATION_COLOR: "green",
  TIMECLASS_SALARIED: "7",
  TIMECLASS_SALARIED_COLOR: "yellow",
  TIMECLASS_PTO_COLOR: "purple-dark",
  TIMECLASS_ALL: "1,2,3,4,5,6,7,8",
  TIMECLASS_STANDARD: "1",
  TIMECLASS_OTHER1: "6",
  TIMECLASS_HOLIDAY: "5",
  TIMECLASS_STANDARD_COLOR: "none",
  TIMECLASS_PTO: "4",
  TIMECLASS_SICK_COLOR: "red",
  TIMECLASS_HOLIDAY_COLOR: "blue"
};
CONST_GROUPS["TIME_ZONE_DEFAULTS"] = {
  DEFAULT_ADMIN_TIME_ZONE_ID: "32"
};
CONST_GROUPS["USER_DISPLAY_PREFERENCES"] = {
  ANNOUNCEMENT_DISPLAY: "ANNOUNCEMENT",
  USER_SETTINGS_DISPLAY: "EMPSETTINGS",
  EXPENSE_DISPLAY: "EXPENSE",
  DEFAULT_EMPLOYEE_DISPLAY_LIST: "HOURLY,PROJECT,EXPENSE,ANNOUNCEMENT",
  HOURLY_DISPLAY: "HOURLY",
  HR_DISPLAY: "HR",
  PROJECT_DISPLAY: "PROJECT"
};
CONST_GROUPS["USER_LOGIN_SETTINGS"] = {
  MAX_SITEADMIN_LOGIN_ATTEMPTS: "5",
  USER_LOGIN_TIMEOUT_MINUTES: "30",
  SITEADMIN_LOGIN_TIMEOUT_MINUTES: "60",
  MAX_USER_LOGIN_ATTEMPTS: "5"
};
CONST_GROUPS["USER_PAY_TYPES"] = {
  PAY_TYPE_HOURLY: "HOURLY",
  PAY_TYPE_SALARY: "SALARY"
};
CONST_GROUPS["USER_PERMISSION_FLAGS"] = {
  ACCESS_EVENTS: "549755813888",
  ACCESS_ACCOUNT_SECURITY: "8192",
  SCHEDULE_VIEWABLE_SUPER_ALL: "2147483648",
  ACCESS_CUSTOMERS: "16384",
  SCHEDULE_VIEWABLE_SUB_LOCAL: "68719476736",
  SCHEDULE_VIEWABLE_PEER_ALL: "17179869184",
  ACCESS_VENDORS: "4096",
  ACCESS_BILLING: "1024",
  SCHEDULE_VIEWABLE_PEER_LOCAL: "8589934592",
  ACCESS_ASSIGNED_USER_RECORDS: "32768",
  ACCESS_PROJECTS: "32",
  ACCESS_TEAM_STATUS: "4",
  ACCESS_VENDORS_INDIV: "268435456",
  ACCESS_NONASSIGNED_SUPERVISOR: "8388608",
  SCHEDULE_VIEWABLE_SUPER_LOCAL: "1073741824",
  ACCESS_NONASSIGNED_USER_ALERTS: "524288",
  BASIC_SUPERVISOR_PERMISSION_FLAGS: "1056960763",
  SCHEDULE_VIEWABLE_SUB_DIRECT: "34359738368",
  ACCESS_PROJECTS_INDIV: "134217728",
  ACCESS_PAYROLL_APPROVE: "512",
  USER_PERMISSION_NOT_USED_41: "2199023255552",
  DEFAULT_PRIMARY_ADMIN_PERMISSION_FLAGS: "1073739259",
  ACCESS_ACCOUNTCODES_INDIV: "67108864",
  DEFAULT_ADMIN_PERMISSION_FLAGS: "1056962043",
  ACCESS_NONASSIGNED_USERS: "8",
  ACCESS_ASSIGNED_USER_ALERTS: "65536",
  ACCESS_ADD_USERS: "128",
  ACCESS_BILLABLE_PROP_INDIV: "2",
  USER_PERMISSION_NOT_USED_44: "17592186044416",
  ACCESS_ASSIGNED_USER_HRDOCS: "131072",
  ACCESS_SNAPSHOT: "64",
  USER_PERMISSION_NOT_USED_43: "8796093022208",
  DEFAULT_EMPLOYEE_PERMISSION_FLAGS: "0",
  ACCESS_CUSTOMERS_INDIV: "536870912",
  ACCESS_BILLPAY_RATES: "33554432",
  SCHEDULE_VIEWABLE_PEER_DIRECT: "4294967296",
  ACCESS_ASSIGNED_USER_PROFILE: "2097152",
  USER_PERMISSION_NOT_USED_42: "4398046511104",
  ACCESS_PAYROLL: "256",
  ACCESS_BILLABLE_PROP: "1",
  DEFAULT_SUPERVISOR_PERMISSION_FLAGS: "0",
  ACCESS_BILLING_APPROVE: "2048",
  SCHEDULE_VIEWABLE_SUB_ALL: "137438953472",
  USER_PERMISSION_NOT_USED_45: "35184372088832",
  ACCESS_NONASSIGNED_USER_HRDOCS: "1048576",
  SCHEDULE_VIEWABLE_SUPER_DIRECT: "274877906944",
  ACCESS_NONASSIGNED_USER_PROFILE: "4194304",
  ACCESS_NONASSIGNED_USER_RECORDS: "262144",
  ACCESS_ACCOUNTCODES: "16",
  ACCESS_EVENTS_INDIV: "1099511627776",
  ACCESS_NONASSIGNED_ADMINISTRATOR: "16777216"
};
CONST_GROUPS["USER_PREFERENCES"] = {
  USER_PREFERENCE_WEEKSTART_TUESDAY: "8",
  USER_PREFERENCE_WEEKSTART_LIST: "2,4,8,16,32,64,128",
  USER_PREFERENCE_WEEKSTART_MONDAY: "4",
  USER_PREFERENCE_ENABLE_LOGIN_LINKS: "1024",
  USER_PREFERENCE_PAUSE_PROJECTTIMERS_ON_CLOCKOUT: "1",
  USER_PREFERENCE_WEEKSTART_WEDNESDAY: "16",
  USER_PREFERENCE_WEEKSTART_SUNDAY: "2",
  USER_PREFERENCE_NO_MARKETING_CONTACT: "512",
  USER_PREFERENCE_STOP_PROJECTTIMERS_ON_CLOCKOUT: "256",
  USER_PREFERENCE_WEEKSTART_SATURDAY: "128",
  USER_PREFERENCE_WEEKSTART_THURSDAY: "32",
  USER_PREFERENCE_WEEKSTART_FRIDAY: "64"
};
CONST_GROUPS["USER_QUOTES_FLAGS"] = {
  USER_QUOTES_ACCESS: "1"
};
CONST_GROUPS["USER_SECURITY_SETTINGS"] = {
  USER_PASSWORD_RESET_TRIGGER: "3000-01-01 00:00:00",
  ALLOW_PROJECT_ENTRY_WITHOUT_ALERT: "16",
  FINGERPRINT_LOGIN_REQUIRED: "8",
  PHOTO_TIMESTAMP_REQUIRED: "4",
  IP_LOCK_REQUIRED: "1",
  ALLOW_HOURLY_ENTRY_WITHOUT_ALERT: "32",
  DEFAULT_EMPLOYEE_SECURITY_FLAGS: "1",
  GEOLOCATION_REQUIRED: "128",
  NOT_USED_SECURITY_SETTING: "2",
  DEFAULT_SUPERVISOR_SECURITY_FLAGS: "1",
  DEFAULT_ADMIN_SECURITY_FLAGS: "48",
  USER_LOGIN_DISABLED: "64"
};
CONST_GROUPS["USER_SETTINGS"] = {
  AUTOMATICSHIFTCLOCKOUT_NO: "0",
  CLOCKINRESTRICTION_NO: "0",
  AUTOMATICSHIFTCLOCKOUT_YES: "1",
  CLOCKINRESTRICTION_YES: "1"
};
CONST_GROUPS["USER_STATUSES"] = {
  USER_STATUS_ALL: "0,1",
  USER_STATUS_ARCHIVED: "0",
  USER_STATUS_ACTIVE: "1"
};
CONST_GROUPS["VALIDATION"] = {
  BILLPAY_RATE_MAX: "10000",
  BILLPAY_RATE_MIN: "0"
};
CONST_GROUPS["VENDOR_STATUSES"] = {
  VENDORSTATUS_ARCHIVED: "0",
  VENDORSTATUS_ACTIVE: "1",
  VENDORSTATUS_ALL: "0,1"
};
